import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useRef } from "react";
import ToolsTable from "../partials/home/ToolsTable";
import VideoYoutube from "../partials/home/VideoYoutube";
import BannerText from "../partials/home/BannerText";
import OwlCarousel from "react-owl-carousel";
import InterviewCall from "../partials/home/InterviewCall";
import MentorsProfile from "../partials/home/MentorsProfile";
import { useIsVisible } from "../hooks/useIsVisible";
import HiringOrganizations from "../partials/home/HiringOrganizations";
import ComparisonWithOther from "../partials/home/ComparisonWithOther";
import Projects from "../partials/home/Projects";
import Certificates from "../partials/home/Certificates";
import CareerServices from "../partials/home/CareerServices";
import CareerServicesAI from "../partials/home/CareerServicesAI";
import CourseReview from "../partials/home/CourseReview";

function Home() {
  const [toggle, setTg] = useState();
  const [activeSection, setActiveSection] = useState("");
  const sectionRef = useRef(null);
  const [isSticky, setIsSticky] = useState(false);
  const navRef = useRef(null);
 

  const overviewSection = useRef();
  const isVisibleOverview = useIsVisible(overviewSection);
  
  const curriculumSection = useRef();
  const isVisibleCurriculum = useIsVisible(curriculumSection);

  const syllabusInDetail = useRef();
  const isVisibleSyllabus = useIsVisible(syllabusInDetail);
  
  const placementSection = useRef();
  const isVisiblePlacement = useIsVisible(placementSection);
  
  const certificationSection = useRef();
  const isVisibleCertification = useIsVisible(certificationSection);

  const projectSection = useRef();
  const isVisibleProject = useIsVisible(projectSection);

  const mentorSection = useRef();
  const isVisibleMentor = useIsVisible(mentorSection);

  const coursereviewSection = useRef();
  const isVisibleCoursereview = useIsVisible(coursereviewSection);

  const feeSection = useRef();
  const isVisibleFee = useIsVisible(feeSection);

  const faqSection = useRef();
  const isVisibleFaq = useIsVisible(faqSection);

  const contactSection = useRef();
  const isVisibleContact = useIsVisible(contactSection);



 

  useEffect(() => {
    const activeItem = document.querySelector('.scrollble-tab-li.active');
    if (activeItem) {
      const list = document.getElementById('scrollble-ul-page');
      const scrollLeft = activeItem.offsetLeft - (list.offsetWidth / 2) + (activeItem.offsetWidth / 2);
      setTimeout(() => {
        list.scrollLeft = scrollLeft;
      }, 750)
      
    }
  }, [
    isVisibleOverview, isVisibleCurriculum, isVisibleSyllabus, isVisibleProject , isVisiblePlacement, isVisibleCertification, isVisibleMentor, isVisibleCoursereview, isVisibleFee, isVisibleFaq,isVisibleContact
  ])


  

  // if(isVisibleOverview) {
  //   console.log('this "overviewSection" section is now visible');
  // }


  useEffect(() => {

    const navContainer = navRef.current;

    const toggleSyllabusButtonsVisibility = (entries) => {
      const isVisible = entries[0].isIntersecting;
      navContainer.classList.toggle("sticky-section", isVisible);
    };


    const isSmallScreen = window.innerWidth < 767;

    if (isSmallScreen) {
      const navContainerHeight = navContainer.clientHeight;
      const navThreshold = 200 / navContainerHeight;


      const options = {
        threshold: [navThreshold],
      };

      if (navThreshold <= 0.5) {
        const navObserver = new IntersectionObserver(
          toggleSyllabusButtonsVisibility,
          options
        );
        navObserver.observe(navContainer);
      } else {
        console.error("Syllabus threshold exceeds 1. Please adjust the value.");
      }


    }

    // Return empty cleanup function if not a small screen
    return () => {
      const navObserver = new IntersectionObserver(
        toggleSyllabusButtonsVisibility
      );
      navObserver.unobserve(navContainer);
    };
  }, []);

 
  // useEffect(() => {
  //   const handleScroll = () => {
  //     const topOffset = sectionRef.current.getBoundingClientRect().top;
  //     setIsSticky(window.pageYOffset > topOffset);
  //   };

  //   window.addEventListener("scroll", handleScroll);

  //   return () => {
  //     window.removeEventListener("scroll", handleScroll);
  //   };
  // }, []);





/**
 * 
 * 
 * 
 * 
 * 
 * 
  useEffect(() => {
    const handleScroll = () => {
      const currentScrollPos = window.pageYOffset;
      const sections = document.querySelectorAll("section");

      sections.forEach((section) => {
        const sectionTop = section.offsetTop - 350; // adjust 50 to the height of your fixed header
        const sectionBottom = sectionTop + section.offsetHeight;

        if (
          currentScrollPos >= sectionTop &&
          currentScrollPos < sectionBottom
        ) {
          const activeItem = document.querySelector('.scrollble-tab-li.active');
          if (activeItem) {
            const list = document.getElementById('scrollble-ul-page');
            const scrollLeft = activeItem.offsetLeft - (list.offsetWidth / 2) + (activeItem.offsetWidth / 2);
            list.scrollLeft = scrollLeft;
          }

          setActiveSection(section.id);
        }
      });
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
 * 
 * 
 * 
 * 
 * 
 * 
*/





  // useEffect(() => {
  //   // Load YouTube Iframe Player API
  //   const tag = document.createElement("script");
  //   tag.src = "https://www.youtube.com/iframe_api";
  //   const firstScriptTag = document.getElementsByTagName("script")[0];
  //   firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  //   var videoWrap = document.querySelector(".video-wrap");
  //   var video = document.querySelector(".video");
  //   var videoHeight = video.offsetHeight;
  //   var state;

  //   function getVideoID() {
  //     var videoIframe = document.querySelector("iframe");
  //     var videoURL = videoIframe.getAttribute("src");
  //     var id = videoURL.split("/")[4].split("?")[0];
  //     var playerDiv = document.createElement("div");
  //     playerDiv.setAttribute("id", "player");
  //     videoIframe.parentNode.insertBefore(playerDiv, videoIframe.nextSibling);
  //     videoIframe.parentNode.removeChild(videoIframe);
  //     return id;
  //   }
  //   window.onYouTubeIframeAPIReady = () => {
  //     var videoID = getVideoID();
  //     const player = new window.YT.Player("player", {
  //       width: "100%",
  //       height: "450",
  //       videoId: videoID,
  //       events: {
  //         // onReady: onPlayerReady,
  //         onStateChange: onPlayerStateChange,
  //       },
  //     });

  //     // function onPlayerReady(event) {
  //     //   event.target.playVideo();
  //     // }

  //     function onPlayerStateChange(event) {
  //       state = event.target.getPlayerState();
  //       if (state == 2) {
  //         video.classList.remove("stuck");
  //         video.classList.remove("stuck");
  //       }

  //       window.addEventListener("scroll", function () {
  //         var windowScrollTop =
  //           window.pageYOffset || document.documentElement.scrollTop;
  //         var videoBottom = videoHeight + videoWrap.offsetTop;
  //         if (state == 1) {
  //           if (windowScrollTop > videoBottom) {
  //             videoWrap.style.height = videoHeight + "px";
  //             video.classList.add("stuck");
  //           } else {
  //             videoWrap.style.height = "auto";
  //             video.classList.remove("stuck");
  //           }
  //         }
  //       });
  //     }
  //   };
  // }, []);

  return (
    <div>
      <meta property="og:type" content="article" />
      <meta
        property="og:title"
        content="Full Stack Developer Course Online (2024)"
      />
      <meta
        property="og:description"
        content="Join Logicmojo Full Stack Developer Course to secure top tech jobs with up to 24 LPA salary. Become a certified Full Stack Web Developer in 180 Days."
      />
      <meta
        property="og:url"
        content="https://logicmojo.com/full-stack-developer-course"
      />
      <meta property="og:site_name" content="Logicmojo" />
      <meta
        property="article:modified_time"
        content="2024-01-30T11:45:44+00:00"
      />
      <meta name="twitter:card" content="summary_large_image" />
      <meta
        name="twitter:image"
        content="https://logicmojo.com/assets/dist/new_pages/images/datas.png"
      />
      <meta name="twitter:label1" content="Est. reading time" />
      <meta name="twitter:data1" content="1 minute" />

      <div className="fulltrakmenu sticky secondmenu " id="secondmenu">
        <div className="container d-flex justify-content-between align-items-center" style={{ paddingTop: 10 + "px" }}>
          <a className="navbar-brand" href="/">
            <img width={150} src="assets/images/LogicmojoLogo.png" alt="" className="new_logo " />
          </a>
          <div className="ml-auto">
            <a target="_default"
              href="https://calendly.com/logicmojo/30min"
              className="enroll-btn btn btn-danger"
            >
              <b>Apply Now</b>
            </a>
          </div>
        </div>
      </div>

      <div className="banner-ai">
        <div className="container position-relative">
          <div className="banner-ai-inner">
            <div className="banner-ai-links">
              <ul>
                <li>
                  <Link to="https://logicmojo.com">Home</Link>
                </li>
                <li>
                  <a href="">Full Stack Developer Course</a>
                </li>
              </ul>
            </div>
            <div className="bestsaller">
              <span>
                <i className="fa fa-star" aria-hidden="true"></i> Bestseller
              </span>
            </div>
            <div className="bestsaller">
              <div className="ratinglink">
                Review 4.8
                <div className="ratingstarfa">
                  <i className="fa fa-star" aria-hidden="true"></i>
                  <i className="fa fa-star" aria-hidden="true"></i>
                  <i className="fa fa-star" aria-hidden="true"></i>
                  <i className="fa fa-star" aria-hidden="true"></i>
                  <i className="fa fa-star" aria-hidden="true"></i>
                </div>
                <a href="#coursereview">(84595 Ratings)</a>
              </div>
            </div>
            <BannerText />
            {/* <div className="banner-ai-text">
              <h1>Full Stack Developer Course by Logicmojo</h1>
              <p>
                Gain expertise in full stack Development from leading professionals worldwide. Master Full Stack Development by enrolling in our comprehensive full stack developer
                course for working professionals.
              </p>
            </div> */}

            <div className="banner-ai-btngrp">
              <a
                target="_default"
                href="https://calendly.com/logicmojo/30min"
                className="counsbtn btnstyle002"
              >
                Apply Now
              </a>
            </div>

            <div className="banner-ai-experts">
              <p>
                Prepared By Industry Top <a href="#mentor" style={{ color: '#ff9900' }}><u><b>Mentors</b></u></a>
              </p>
             
{/*
              <a href="">
                <img alt="" src="assets/images/gramener.png" />
              </a>
              <a href="">
                <img alt="" src="assets/images/actify.png" />
              </a>
              <a href="">
                <img src="assets/images/flipcart.png" alt="" />
              </a>
              <a href="">
                <img src="assets/images/walmart.png" alt="" />
              </a>
              <a href="">
                <img alt="" src="assets/images/zee.png" />
              </a>
          */}
            </div>
          </div>
        </div>
      </div>
      <div className="banner-aistrip">
        <div className="container">
          <ul>
            <li>
              <span>
                <img src="assets/images/banner-aistrip-icon1.png" alt="" />
              </span>
              <div className="banner-aistrip-text">
              <div style={{ fontSize: 14}}><b>120% Average Hike</b></div>
              <div style={{ fontsize: 14 }}>in Job Switch</div>
              </div>
            </li>
            <li>
              <span>
                <img src="assets/images/banner-aistrip-icon2.png" alt="" />
              </span>
              <div className="banner-aistrip-text">
              <div style={{ fontSize: 14 }}><b>7 Months</b></div>
              <div style={{ fontsize: 14 }}>Weekend Live Classes</div>
              </div>
            </li>
            <li>
              <span>
                <img src="assets/images/banner-aistrip-icon3.png" alt="" />
              </span>
              <div className="banner-aistrip-text">
              <div style={{ fontSize: 14 }}><b>1.3 Cr Highest CTC</b></div>
              <div style={{ fontsize: 14 }}>(In Microsoft, India)</div>
              </div>
            </li>
            <li>
              <span>
                <img src="assets/images/banner-aistrip-icon4.png" alt="" />
              </span>
              <div className="banner-aistrip-text">
              <div style={{ fontSize: 14 }}><b>Job Assistance</b></div>
              <div style={{ fontsize: 14 }}>100% Placements</div>
              </div>
            </li>
            <li>
              <span>
                <img src="assets/images/banner-aistrip-icon5.png" alt="" />
              </span>
              <div className="banner-aistrip-text">
              <div style={{ fontSize: 14 }}><b>Starts at INR 3,800/month*</b></div>
                <div style={{ fontsize: 14 }}>EMI Options Available</div>
              </div>
            </li>
          </ul>
        </div>
        
      </div>
     
      {/*<InterviewCall />*/}

 
     

      <section
        className="sec-navbar"
      >

       

<nav className="container d-flex justify-content-between align-items-center">
          <ul id="scrollble-ul-page">

          <li className={`scrollble-tab-li ${isVisibleCurriculum && !isVisibleOverview ? "active" : ""}`}>
              <a href="#curriculum">Curriculum</a>
            </li>

            <li className={`scrollble-tab-li ${isVisibleOverview && !isVisibleCoursereview ? "active" : ""}`}>
              <a href="#Overview">Overview</a>
            </li>
            <li className={`scrollble-tab-li ${isVisibleCoursereview && !isVisibleSyllabus ? "active" : ""}`}>
              <a href="#coursereview">Reviews</a>
            </li>
            <li className={`scrollble-tab-li ${isVisibleSyllabus ? "active" : ""}`}>
              <a href="#syllabus">Syllabus</a>
            </li>
            <li className={`scrollble-tab-li ${isVisibleCertification && !isVisibleProject ? "active" : ""}`}>
              <a href="#certification">Certification</a>
            </li>

             <li className={`scrollble-tab-li ${isVisibleProject && !isVisibleMentor ? "active" : ""}`}>
              <a href="#projects">Projects</a>
            </li>

            <li className={`scrollble-tab-li ${isVisibleMentor && !isVisiblePlacement ? "active" : ""}`}>
              <a href="#mentor">Mentor</a>
            </li>
            
            <li className={`scrollble-tab-li ${isVisiblePlacement && !isVisibleFee ? "active" : ""}`}>
              <a href="#placement">Placement</a>
            </li>         
            
            <li className={`scrollble-tab-li ${isVisibleFee && !isVisibleFaq ? "active" : ""}`}>
              <a href="#fee">Fee</a>
            </li>
            <li className={`scrollble-tab-li ${isVisibleFaq && !isVisibleContact  ? "active" : ""}`}>
              <a href="#faq">FAQs</a>
            </li>
            <li className={`scrollble-tab-li ${isVisibleContact ? "active" : ""}`}>
              <a href="#contact">Contact</a>
            </li>

          </ul>
          {/* -- this one 
          <div style={{ paddingLeft: 10 + "px" }}>
            <a
              target="_default"
              href="https://calendly.com/logicmojo/30min"
              className="enroll-btn btn btn-danger"
            >
              <b>Register Yourself!</b>
            </a>
          </div>
      */}
        </nav>
      </section>


      
{/*
      <center><br /><br /><h2 style={{ fontSize: 25 }}><span>Course Reviews</span></h2></center>

      <div className="review-courses-block">
        <div className="container">
          <div className="reclogoinfo">
            <ul>
              <li>
                <div className="reclogdiv">
                  <a href="https://www.switchup.org/bootcamps/logicmojo"><img src="assets/images/switch-UP.png" border="0" alt="" /></a>
                </div>
                <p>
                  4.9<span className="fa fa-star checked"></span>
                </p>
              </li>
              <li>
                <div className="reclogdiv">
                  <a href="https://www.google.com/search?q=logicmojo&oq=logicmojo+&gs_lcrp=EgZjaHJvbWUyBggAEEUYOTIGCAEQRRg8MgcIAhAAGIAEMgYIAxAjGCcyBggEEEUYQTIGCAUQRRg8MgYIBhBFGDwyBggHEEUYPNIBCTIyMjc0ajBqN6gCALACAA&sourceid=chrome&ie=UTF-8#lrd=0x3bae15239d632ad3:0x8248087353e6d723,1,,,,"><img src="assets/images/googlereview.jpg" border="0" alt="" /></a>
                </div>
                <p>
                  4.8<span className="fa fa-star checked"></span>
                </p>
              </li>
              <li>
                <div className="reclogdiv">
                  <a href="https://www.trustpilot.com/review/logicmojo.com"><img src="assets/images/trustpilot.jpg" border="0" alt="" /></a>
                </div>
                <p>
                  4.7<span className="fa fa-star checked"></span>
                </p>
              </li>
              <li>
                <div className="reclogdiv">
                  <a href="https://www.justdial.com/Bangalore/Logic-Mojo-Kadubeesanahalli/080PXX80-XX80-220129215746-F5U9_BZDET"><img src="assets/images/justdial.jpg" border="0" alt="" /></a>
                </div>
                <p>
                  4.7<span className="fa fa-star checked"></span>
                </p>
              </li>
              <li>
                <div className="reclogdiv">
                  <a href="https://www.ambitionbox.com/reviews/logicmojo-academy-reviews"><img src="assets/images/ambitionbox.jpg" border="0" alt="" /></a>
                </div>
                <p>
                  5<span className="fa fa-star checked"></span>
                </p>
              </li>

              <li>
                <div className="reclogdiv">
                  <a href="https://www.quora.com/What-is-your-review-after-subscribing-to-the-Data-Structure-Algorithms-System-Design-online-course-by-Logicmojo"><img src="assets/images/Quora.jpg" border="0" alt="" /></a>
                </div>


              </li>
              <li>
                <div className="reclogdiv">
                  <a href="https://medium.com/@rajjsr087/logicmojo-review-f5f393216968"><img src="assets/images/medium.jpg" border="0" alt="" /></a>
                </div>

              </li>
            </ul>
          </div>
        </div>

      </div>
    */}
    
   <br/>
   <br/>
   
   <br/>
  

  
   <section ref={curriculumSection} className="whymakesnew" id="Overview1">
   <div className="container">
   <h2 style={{ fontSize: '32px', fontFamily: "'DM Serif Display', serif" }}>
    <br/>
            <b>Course Highlights</b>
          </h2>
          
          <div className="coursesbg liveprogrambg">
        <div className="container">
          <ul className="nav nav-pills mb-3" id="pills-tab" role="tablist">
            
          </ul>

          <div className="tab-content" id="pills-tabContent">
           
              <div className="liveprogram-innerbg">
                {/*
              <h1>
                  What are the <span>Course Overview</span> for
                  you
                </h1>
              */}

                <div className="row align-items-center justify-content-center" >
                  <div className="col-lg-3 col-md-4">
                    <div className="flip-card">
                      <div className="flip-card-inner">
                        <div className="flip-card-front">
                          <img
                            loading="lazy"
                            src="assets/images/overviewImage/live-interactive.png"
                            alt=""
                          />
                          <h3>Live Interactive Sessions</h3>
                        </div>
                        <div className="flip-card-back">
                        Get Trained by Expert Data Scientists in Live Classes
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-4">
                    <div className="flip-card">
                      <div className="flip-card-inner">
                        <div className="flip-card-front">
                          <img
                            loading="lazy"
                            src="assets/images/overviewImage/liveicon-1.png"
                            alt=""
                          />
                          <h3> Practical Experience through Projects</h3>
                        </div>
                        <div className="flip-card-back">
                          Practical experience through real-time 8+ projects
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-4">
                    <div className="flip-card">
                      <div className="flip-card-inner">
                        <div className="flip-card-front">
                          <img
                            loading="lazy"
                            src="assets/images/overviewImage/liveicon-2.png"
                            alt=""
                          />
                          <h3> 1:1 doubt clearing sessions</h3>
                        </div>
                        <div className="flip-card-back">
                          Personalized programs with Live classes and 1:1 doubt
                          clearing sessions/mentorship sessions.
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-4">
                    <div className="flip-card">
                      <div className="flip-card-inner">
                        <div className="flip-card-front">
                          <img
                            loading="lazy"
                            src="assets/images/overviewImage/liveicon-3.png"
                            alt=""
                          />
                          <h3>Job Assistance Program</h3>
                        </div>
                        <div className="flip-card-back">
                          Job Referrals in Product Companies, Resume Preparation
                          Session and Mock interviews
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-4">
                    <div className="flip-card">
                      <div className="flip-card-inner">
                        <div className="flip-card-front">
                          <img
                            loading="lazy"
                            src="assets/images/overviewImage/liveicon-4.png"
                            alt=""
                          />
                          <h3>Missed Classes ?</h3>
                        </div>
                        <div className="flip-card-back">
                          Attend multiple batches with multiple trainers if you
                          miss any sessions or Topic for 1 Year subscription.
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-4">
                    <div className="flip-card">
                      <div className="flip-card-inner">
                        <div className="flip-card-front">
                          <img
                            loading="lazy"
                            src="assets/images/overviewImage/liveicon-5.png"
                            alt=""
                          />
                          <h3>Life Time Access</h3>
                        </div>
                        <div className="flip-card-back">
                          Missed Classes, get lifetime access recorded lectures
                          of all classes
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-4">
                    <div className="flip-card">
                      <div className="flip-card-inner">
                        <div className="flip-card-front">
                          <img
                            loading="lazy"
                            src="assets/images/overviewImage/liveicon-6.png"
                            alt=""
                          />
                          <h3>peer to Peer Learning?</h3>
                        </div>
                        <div className="flip-card-back">
                          Slack group for peer-to-peer learning & discussion
                          with batchmates. Case studies & GitHub for
                          Code review.
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-4">
                    <div className="flip-card">
                      <div className="flip-card-inner">
                        <div className="flip-card-front">
                          <img
                            loading="lazy"
                            src="assets/images/overviewImage/liveicon-7.png"
                            alt=""
                          />
                          <h3>Flexible Pay</h3>
                        </div>
                        <div className="flip-card-back">
                          Flexible EMI options on Credit cards and Debit cards.
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-4">
                    <div className="flip-card">
                      <div className="flip-card-inner">
                        <div className="flip-card-front">
                          <img
                            loading="lazy"
                            src="assets/images/overviewImage/selfpaced-2.png"
                            alt=""
                          />
                          <h3>Assignments for Practise After Class</h3>
                        </div>
                        <div className="flip-card-back">
                          Solve Assignments after every classes. Full Stack Study Materials & project work.
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-4">
                    <div className="flip-card">
                      <div className="flip-card-inner">
                        <div className="flip-card-front">
                          <img
                            loading="lazy"
                            src="assets/images/overviewImage/selfpaced-6.png"
                            alt=""
                          />
                          <h3>Weekly Tests</h3>
                        </div>
                        <div className="flip-card-back">
                          Evaluate yourself in competitive tests with
                          your batchmates in full stack development
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
           
          </div>
          <br/>
   
       
        </div>

   
   <br/>

        <div style={{ width: "250px", margin: "0 auto" }}>
          {/* <a
            target="_default"
            href="https://calendly.com/logicmojo/career-counselling-live-classes?month=2023-08"
            className="counsbtn2"
          >
            Apply For Live Classes{" "}
            <i className="fa fa-angle-right arrowclass" aria-hidden="true"></i>
          </a> */}

          
        </div>
      </div>
      </div>
   <div className="container">
     
   <HiringOrganizations />
   </div>
   <br/>
   </section>

   <section ref={overviewSection} className="whymakesnew" id="Overview">
        <div className="container">
        <br/>
        <h2 style={{ fontSize: '32px', fontFamily: "'DM Serif Display', serif" }}><b>
          Full Stack Developer</b><b style={{color:"#9769ef" }}> Course Overview</b> 
          </h2>
          
          <br />
            
            <p style={{fontSize: 14}}>Logicmojo's <a href="https://logicmojo.com/full-stack-developer">full stack developer</a> program helps you learn exactly everything that you need to solidify your tech career.</p>
            <p style={{fontSize: 14}}>Full Stack Web Development: Complete tech stack in live classes, covering frontend technologies include <a href="https://logicmojo.com/html-interview-questions">HTML</a>, CSS, <a href="https://logicmojo.com/react-js-interview-questions">ReactJS</a>, and <a href="https://logicmojo.com/angular-interview-questions">Angular</a>. Backend technologies include <a href="https://logicmojo.com/javascript-interview-questions">JavaScript</a>, Node.js, Express.js, and <a href="https://logicmojo.com/spring-boot-interview-questions">Spring</a>. Additionally, complete <a href="https://logicmojo.com/devops-interview-questions">DevOps</a> with database operations like <a href="https://logicmojo.com/sql-interview-questions">SQL</a>/<a href="https://logicmojo.com/mysql-interview-questions">MySQL</a> and <a href="https://logicmojo.com/nosql-database">NoSQL</a></p>

          
        </div>
      </section>
      
   
    

      <div className="ourclientbg-new" id="Overview">
        <div className="container">
          <h3 style={{ fontSize: 20 }}>Where Our <b style={{color:"#9769ef" }}>Alumni Work</b>?</h3>
          <p style={{fontSize: 14}}>Candidates who complete the full stack development course from Logicmojo are placed in product-based companies.</p>
          <div className="owl-carousel owl-theme">
            <div className="item">
              <img src="assets/images/microsofticon.png" alt="" />
              <img src="assets/images/walmarticon.png" alt="" />
              <img src="assets/images/googleicon.png" alt="" />
            </div>
            <div className="item">
              <img src="assets/images/amazonicon.png" alt="" />
              <img src="assets/images/flipcarticon.png" alt="" />
              <img src="assets/images/makemytrip.jpeg" alt="" />
            </div>
            <div className="item">
              <img src="assets/images/vmware.jpg" alt="" />
              <img src="assets/images/intuit.jpg" alt="" />
              <img src="assets/images/meta.jpg" alt="" />
            </div>
            <div className="item">
              <img src="assets/images/oracle.jpg" alt="" />
              <img src="assets/images/ciscologo.jpg" alt="" />
              <img src="assets/images/adobe.jpg" alt="" />
            </div>
            <div className="item">
              <img src="assets/images/intel.jpg" alt="" />
              <img src="assets/images/walmarticon.png" alt="" />
              <img src="assets/images/paypal.jpg" alt="" />
            </div>
            <div className="item">
              <img src="assets/images/amazonicon.png" alt="" />
              <img src="assets/images/flipcarticon.png" alt="" />
              <img src="assets/images/sony.jpg" alt="" />
            </div>
          </div>
        </div>
      </div>

      

      
      <section className="careeroppbg" >
        <center>
          <div style={{ paddingLeft: 10 + "px" }}>
            <a
              target="_default"
              href="https://calendly.com/logicmojo/30min"
              className="btn btn-danger secondmenu_btn"
            >
              <b>Apply For Live Classes</b>
            </a>
          </div>
        </center>
      </section>

      <section ref={coursereviewSection} className="datareviewsbg" id="coursereview">
        <div  className="whatpeoplesaybg" id="Review">

          <div className="container">
            <h2 style={{ fontSize: '32px', fontFamily: "'DM Serif Display', serif" }}><b>Full Stack Developer</b><b style={{fontFamily: "'DM Serif Display', serif", color:"#9769ef" }}> Career Transitions!</b></h2><br/>
            <div className="d-none text-center mb-5" style={{ fontSize: 18 }}>
              How it has helped candidates to accelerate their careers in Full Stack Developer roles.
            </div>
            
            <CourseReview />
          </div>
          <VideoYoutube />



          <div className="mt-4" style={{ textAlign: "center" }}>
            <a
              target="_default"
              href="https://logicmojo.com/success-story"
              className="btn btn-primary"
            >
              Check Success Story
            </a>
          </div>

        </div>
        
        {/*
        <div className="container">
          <h3>Learner Reviews for our Data Science Programs</h3>

          <div className="row">
            <div className="col-md-6">
              <div className="datareview">
                <div className="datareview-head">
                  <div>
                    <img src="assets/images/mac/shivam.jpg" alt="" />
                  </div>
                  <div className="datareview-head-right">
                    <h3>Shivam Bajpai</h3>
                    <p style={{ fontsize: 14 }}>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                    </p>
                  </div>
                </div>
                <p style={{ fontsize: 14 }}>
                  I recently wrapped up a data science course and would like to
                  discuss my impressions and insights from the program. Overall,
                  I believe the course is a great asset for those interested in
                  entering the data science field or improving their current
                  abilities. The course curriculum was skillfully crafted,
                  encompassing all key aspects of data science, such as
                  statistics, Python, machine learning, data analysis, and
                  large-scale data processing. The lessons were thoughtfully
                  arranged, beginning with fundamental concepts and gradually
                  advancing to more complex topics, making it simple to
                  comprehend and follow the material.
                </p>
              </div>
            </div>

            <div className="col-md-6">
              <div className="datareview">
                <div className="datareview-head">
                  <div>
                    <img src="assets/images/mac/puneet.jpg" alt="" />
                  </div>
                  <div className="datareview-head-right">
                    <h3>Puneet</h3>
                    <p style={{ fontsize: 14 }}>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                    </p>
                  </div>
                </div>
                <p style={{ fontsize: 14 }}>
                  I recently completed an online data science course and would
                  like to share my feedback and experiences about the program.
                  The course proved to be an exceptional learning opportunity
                  for those looking to delve into data science or improve their
                  existing skills in the field. The course was meticulously
                  structured, encompassing a broad array of crucial data science
                  topics.The instructors were not only experts in their
                  respective fields but also highly accessible and supportive.
                  They offered clear explanations and promptly addressed any
                  questions or concerns
                </p>
              </div>
            </div>

            <div className="col-md-6">
              <div className="datareview">
                <div className="datareview-head">
                  <div>
                    <img src="assets/images/mac/diwakar.png" alt="" />
                  </div>
                  <div className="datareview-head-right">
                    <h3>Diwakar Choudhary</h3>
                    <p style={{ fontsize: 14 }}>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                    </p>
                  </div>
                </div>
                <p style={{ fontsize: 14 }}>
                  A key aspect of the data science course was its emphasis on
                  practical, hands-on learning experiences. Throughout the
                  program, students were tasked with completing a variety of
                  assignments, quizzes, and projects, encouraging them to apply
                  their newfound knowledge to real-world scenarios. This
                  approach not only deepened my understanding of the subject
                  matter but also allowed me to build a compelling portfolio to
                  showcase my skills to prospective employers.
                </p>
              </div>
            </div>

            <div className="col-md-6">
              <div className="datareview">
                <div className="datareview-head">
                  <div>
                    <img src="assets/images/mac/afnaan.png" alt="" />
                  </div>
                  <div className="datareview-head-right">
                    <h3>Afnaan Rafique</h3>
                    <p style={{ fontsize: 14 }}>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                    </p>
                  </div>
                </div>
                <p style={{ fontsize: 14 }}>
                  The online format of the data science course provided the
                  flexibility to learn at my own pace and according to my
                  schedule. This was particularly beneficial for individuals,
                  like myself, balancing work, family, and other commitments,
                  making it an appealing option for learners with varying levels
                  of availability.
                </p>
              </div>
            </div>

            <div className="col-md-6">
              <div className="datareview">
                <div className="datareview-head">
                  <div>
                    <img src="assets/images/mac/piyush.jpg" alt="" />
                  </div>
                  <div className="datareview-head-right">
                    <h3>Piyush Mittal</h3>
                    <p style={{ fontsize: 14 }}>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                    </p>
                  </div>
                </div>
                <p style={{ fontsize: 14 }}>
                  A crucial element of the data science course focused on
                  providing practical, experiential learning opportunities.
                  During the program, students engaged in numerous tasks, tests,
                  and projects that pushed them to utilize their acquired
                  knowledge in real-life situations. This method not only
                  enriched my comprehension of the topics but also enabled me to
                  create an impressive portfolio to demonstrate my abilities to
                  potential employers.
                </p>
              </div>
            </div>

            <div className="col-md-6">
              <div className="datareview">
                <div className="datareview-head">
                  <div>
                    <img src="assets/images/mac/priya.png" alt="" />
                  </div>
                  <div className="datareview-head-right">
                    <h3>Priya Singh</h3>
                    <p style={{ fontsize: 14 }}>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                    </p>
                  </div>
                </div>
                <p style={{ fontsize: 14 }}>
                  The digital structure of the data science course allowed for
                  the adaptability to study at a pace and schedule that suited
                  me. This proved to be especially advantageous for people,
                  including myself, who had to juggle work, family, and other
                  responsibilities, rendering it an attractive choice for
                  students with diverse time commitments.
                </p>
              </div>
            </div>
            <center>
              <a
                target="_default"
                href="https://www.google.com/search?q=logicmojo+review&oq=log&aqs=chrome.1.69i65j69i59j46i39i175i199j69i60l4j69i65.1921j0j7&sourceid=chrome&ie=UTF-8#lrd=0x3bae15239d632ad3:0x8248087353e6d723,1,,,,"
                className="btn btn-link collapsed"
              >
                View more reviews
              </a>
            </center>
          </div>
        </div>
                                */}
      </section>

      <section ref={syllabusInDetail} className="careerservices-new" id="placement">
      <div className="container clearfix">
        <CareerServicesAI />
        </div>
        </section>

   
        <section  className="certificate-companies"  id="certification">
      
      <div className="my-3 container text-center">
     
      <h2 style={{ fontSize: '32px', fontFamily: "'DM Serif Display', serif" }} className="mb-3 mt-5"><b>Full Stack Development tools </b><b style={{color:"#9769ef" }}>would you learn?</b></h2>

         
<p style={{fontSize: 14}}>The following tools and frameworks for backend and frontend development are covered in the course. After completing the course, you will be an proficient in these frameworks.</p>
<br/>
<div className="row">

  <div className="col-md-3 col-4">
    <div className="highlight-card">

      <img src="assets/images/icons/js.png" alt="img" />
      <h4>JavaScript</h4>
    </div>
  </div>

  <div className="col-md-3 col-4">
    <div className="highlight-card">

      <img src="assets/images/icons/reactjs.png" alt="img" />
      <h4>React</h4>
    </div>
  </div>

  <div className="col-md-3 col-4">
    <div className="highlight-card">

      <img src="assets/images/icons/angular.png" alt="img" />
      <h4>Angular</h4>
    </div>
  </div>

  <div className="col-md-3 col-4">
    <div className="highlight-card">
      <img src="assets/images/icons/htmlcss.png" alt="img" />
      <h4>HTML/CSS</h4>
    </div>
  </div>

  <div className="col-md-3 col-4">
    <div className="highlight-card">

      <img src="assets/images/icons/nodejs.png" alt="img" />
      <h4>Node.js</h4>
    </div>
  </div>

  <div className="col-md-3 col-4">
    <div className="highlight-card">
      <img src="assets/images/icons/express-js.png" alt="img" />
      <h4>Express.js </h4>
    </div>
  </div>

  <div className="col-md-3 col-4">
    <div className="highlight-card">
      <img src="assets/images/icons/vue.png" alt="img" />
      <h4>Vue.js</h4>
    </div>
  </div>

  <div className="col-md-3 col-4">
    <div className="highlight-card">

      <img src="assets/images/icons/resthttp.png" alt="img" />
      <h4>REST/HTTP</h4>
    </div>
  </div>

  <div className="col-md-3 col-4">
    <div className="highlight-card">
      <img src="assets/images/icons/java.png" alt="img" />
      <h4>Java</h4>
    </div>
  </div>

  <div className="col-md-3 col-4">
    <div className="highlight-card">
      <img src="assets/images/icons/springboot.png" alt="img" />
      <h4>SpringBoot</h4>
    </div>
  </div>

  <div className="col-md-3 col-4">
    <div className="highlight-card">
      <img src="assets/images/icons/github.png" alt="img" />
      <h4>GitHub</h4>
    </div>
  </div>

  <div className="col-md-3 col-4">
    <div className="highlight-card">
      <img src="assets/images/icons/mysql.png" alt="img" />
      <h4>MySQL</h4>
    </div>
  </div>

  <div className="col-md-3 col-4">
    <div className="highlight-card">
      <img src="assets/images/icons/mongodb.png" alt="img" />
      <h4>MongoDB</h4>
    </div>
  </div>

  <div className="col-md-3 col-4">
    <div className="highlight-card">
      <img src="assets/images/icons/cassandra.png" alt="img" />
      <h4>Cassandra</h4>
    </div>
  </div>

  <div className="col-md-3 col-4">
    <div className="highlight-card">
      <img src="assets/images/icons/apache.png" alt="img" />
      <h4>Apache</h4>
    </div>
  </div>



</div>
</div>
      </section>

       

     
      <section ref={certificationSection} className="certificate-companies" id="certification">
        <Certificates />

        {/* <hr />
        <div className="container ">
          
          <div className="certificate-companies-text">
            <h2 style={{ fontSize: 29}}>Data Science <b style={{ fontSize: 29, color:"#9769ef"}}>Certification</b></h2>
            <h3 style={{ fontSize: 20}}> Data Science Certification Advantage </h3>
              <br></br>

             
            <ul>
              <h3><li style={{ fontsize: 14 }}>
                <b>Get Ahead with Logicmojo's Master Data Science Certificate</b>
              </li></h3>
              <p style={{ fontSize: 14 }}>
              Earn your professional data science certification with project experience through our accredited data science course. 
              Receive both Data Scientist and Company project certificates to enhance your career prospects in the field of data science. 
              Gain exclusive access to industry-leading expert masterclasses..
              </p>
              <h4><li style={{ fontsize: 14 }}>
                <b>Differentiate yourself with a Masters Certificate</b>
              </li></h4>
              <p style={{ fontSize: 14 }}>
                The understanding and Data Science abilities you've developed
                through projects, simulations, and case studies will put you
                ahead of others.
              </p>
             
            </ul>
            <a target="default" href="https://drive.google.com/file/d/1W_wPuu7vn3RQB-XdtIPCdLGeKPybRElI/view">
              Download Brochure
              <i className="fa fa-long-arrow-right" aria-hidden="true"></i>
            </a>
          </div>
          <div className="certificate-companies-img">
            <img style={{ border: '1px solid #000' }} src="assets/images/certificate-companies.png" alt="" />
          </div>
          <br/><br/>

        </div>


        <div className="container">

                  <div className="certificate-companies-text">
                  <ul>
                  <li style={{ fontsize: 14 }}>
                        <b>Project Experience Certification</b>
                      </li>
                      <p style={{ fontSize: 14 }}>
                        Share your Data Science Projects Certification on LinkedIn, Twitter, and
                        Facebook, enhance your resume, or display it proudly - let your
                        friends and colleagues know about your achievement
                      </p>
                  </ul>
                      </div>

                      <div className="certificate-companies-img">
                <img style={{ border: '1px solid #000' }} src="assets/images/Data Science Certification.jpg" alt="" />
                
                </div>


                    
          </div> */}
         
      </section>

     

      

    

      <section  ref={projectSection}  className="projectsnewbg">
        <div className="container">
          <center>
          <br/><br/>
          <h2 style={{ fontSize: '32px', fontFamily: "'DM Serif Display', serif" }}><b>What’s a great curriculum without</b><b style={{fontFamily: "'DM Serif Display', serif", color:"#9769ef" }}> project-based learning ?</b></h2><br/>
            </center>
          <br></br>
          <p style={{ fontSize: 14 }}>
            Projects will be a part of your Certification in full stack developer
            course to consolidate your learning. <br />
            It will ensure that you have real-world experience in full stack web development.
          </p>
          <div className="projectsnewbg-practice">
            <ul>
              <li>
                <img src="assets/images/practice-icon.png" alt="" />
                <h3>Practice 20+</h3>
                <p>Essential Tools</p>
              </li>
              <li>
                <img src="assets/images/designed-icon.png" alt="" />
                <h3 style={{ color: "#2aacf6" }}>Designed by</h3>
                <p>Industry Experts</p>
              </li>
              <li>
                <img src="assets/images/get-icon.png" alt="" />
                <h3 style={{ color: "#1fcd71" }}>Get Real-world</h3>
                <p>Experience</p>
              </li>
            </ul>
          </div>

          <div className="projectsnewbg-bottom clearfix" ref={navRef}>
            <ul className="nav nav-tabs sticky-nav center-nav" role="tablist">
              <li className="nav-item">
                <a className="nav-link active" data-toggle="tab" href="#tab012">
                  Beginner
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" data-toggle="tab" href="#tab013">
                  Intermediate
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" data-toggle="tab" href="#tab014">
                  Advance
                </a>
              </li>
            </ul>

            <div className="tab-content">
              <div id="tab012" className="tab-pane active">
                <Projects id="1" />
                {/* <OwlCarousel
                  className="owl-theme"
                  loop
                  margin={20}
                  nav
                  navText={[" ", " "]}
                  responsive={{
                    0: {
                      items: 1,
                    },
                    600: {
                      items: 1,
                    },
                    1000: {
                      items: 3,
                    },
                  }}
                >
                  <div className="item">
                    <div className="products_slide">
                      <img src="assets/images/face-detection.png" alt="" />
                      <h3>
                        <span>Face Detection</span>
                      </h3>
                      <p style={{ fontsize: 14 }}>
                        Face Detection is an initiative to create a computer
                        vision model that can automatically detect and locate
                        human faces within images or video frames.The goal of
                        this project is to enable machines to recognize and
                        analyze human faces in various contexts, such as
                        security, entertainment, or social media.
                      </p>
                    </div>
                  </div>
                  <div className="item">
                    <div className="products_slide">
                      <img src="assets/images/alI-chatbot.png" alt="" />
                      <h3>
                        <span>AI Chatbot</span>
                      </h3>
                      <p style={{ fontsize: 14 }}>
                        Artificial intelligence-powered chatbot that can
                        communicate with humans in a natural language.project
                        involves designing, developing, and deploying a chatbot
                        that can perform specific tasks or answer questions for
                        users. The chatbot can be used for various purposes,
                        such as customer support, sales, marketing, or personal
                        assistance
                      </p>
                    </div>
                  </div>
                  <div className="item">
                    <div className="products_slide">
                      <img src="assets/images/restaurant-revenue.png" alt="" />
                      <h3>
                        <span>Restaurant Revenue Prediction</span>
                      </h3>
                      <p style={{ fontsize: 14 }}>
                        Restaurant revenue prediction project is an initiative
                        to create a machine learning model that can forecast the
                        revenue of a restaurant based on various factors such as
                        customer footfall, menu items, prices, and marketing
                        promotions. The goal of this project is to help
                        restaurant owners make data-driven decisions to increase
                        their revenue and profitability.
                      </p>
                    </div>
                  </div>
                  <div className="item">
                    <div className="products_slide">
                      <img src="assets/images/face-detection.png" alt="" />
                      <h3>
                        <span>Face Detection</span>
                      </h3>
                      <p style={{ fontsize: 14 }}>
                        climate change impacts project on the global food supply
                        is an initiative to investigate how climate change will
                        affect food production, distribution, and consumption
                        worldwide. The project aims to provide insights into how
                        these impacts may vary by region, crop type, and
                        socio-economic factors, and to identify potential
                        strategies for adaptation and mitigation.
                      </p>
                    </div>
                  </div>
                  <div className="item">
                    <div className="products_slide">
                      <img src="assets/images/alI-chatbot.png" alt="" />
                      <h3>
                        <span>AI Chatbot</span>
                      </h3>
                      <p style={{ fontsize: 14 }}>
                        Credit card fraud detection using classification
                        algorithms is an initiative to create a machine learning
                        model that can automatically detect fraudulent
                        transactions in credit card transactions. The goal of
                        this project is to enable financial institutions to
                        detect and prevent fraud and protect their customers'
                        financial security.
                      </p>
                    </div>
                  </div>
                  <div className="item">
                    <div className="products_slide">
                      <img src="assets/images/restaurant-revenue.png" alt="" />
                      <h3>
                        <span>Restaurant Revenue Prediction</span>
                      </h3>
                      <p style={{ fontsize: 14 }}>
                        Water quality project using the random forest algorithm
                        in data science is an initiative to create a machine
                        learning model that can predict water quality parameters
                        such as pH, dissolved oxygen, biochemical oxygen demand
                        (BOD), and total suspended solids (TSS). Predict water
                        quality using datasets.
                      </p>
                    </div>
                  </div>
                </OwlCarousel> */}
              </div>

              <div id="tab013" className="tab-pane fade">
                <Projects id="2" />
                <OwlCarousel
                  className="owl-theme"
                  loop
                  margin={20}
                  nav
                  navText={[" ", " "]}
                  responsive={{
                    0: {
                      items: 1,
                    },
                    600: {
                      items: 1,
                    },
                    1000: {
                      items: 3,
                    },
                  }}
                >
                  {/*
                  <div className="item">
                    <div className="products_slide">
                      <img src="assets/images/face-detection.png" alt="" />
                      <h3>
                        <span>Face Detection</span>
                      </h3>
                      <p style={{ fontsize: 14 }}>
                        Purchase prediction of customer using random forest is a
                        data science project that aims to predict whether a
                        customer is likely to make a purchase based on their
                        historical purchase behavior and demographic data. The
                        goal of this project is to help businesses understand
                        their customers' purchasing patterns
                      </p>
                    </div>
                  </div>
                  <div className="item">
                    <div className="products_slide">
                      <img src="assets/images/alI-chatbot.png" alt="" />
                      <h3>
                        <span>AI Chatbot</span>
                      </h3>
                      <p style={{ fontsize: 14 }}>
                        Predicting house prices using regression is a data
                        science project that aims to create a machine learning
                        model that can predict the sale price of a house based
                        on various features such as the number of bedrooms,
                        bathrooms, square footage, location, and age of the
                        property
                      </p>
                    </div>
                  </div>
                  <div className="item">
                    <div className="products_slide">
                      <img src="assets/images/restaurant-revenue.png" alt="" />
                      <h3>
                        <span>
                          Topic Modelling for Twitter Customer Reviews
                          clustering
                        </span>
                      </h3>
                      <p style={{ fontsize: 14 }}>
                        Topic modeling is a powerful technique in natural
                        language processing that can be used to extract and
                        identify themes or topics in a large corpus of text
                        data. In the context of Twitter customer reviews
                        clustering, topic modeling can be used to identify the
                        main themes or topics that customers are discussing in
                        their reviews
                      </p>
                    </div>
                  </div>
                  <div className="item">
                    <div className="products_slide">
                      <img src="assets/images/face-detection.png" alt="" />
                      <h3>
                        <span>Authentic vs. Fake Banknote Classification</span>
                      </h3>
                      <p style={{ fontsize: 14 }}>
                        Using supervised learning algorithms such as logistic
                        regression, decision trees, random forests, or support
                        vector machines (SVMs) used to authentic vs. fake
                        banknote classification.
                      </p>
                    </div>
                  </div>
                  <div className="item">
                    <div className="products_slide">
                      <img src="assets/images/alI-chatbot.png" alt="" />
                      <h3>
                        <span>Restaurant Revenue Prediction</span>
                      </h3>
                      <p style={{ fontsize: 14 }}>
                        Principal Component Analysis (PCA) can help improve the
                        clustering performance by reducing the dimensionality of
                        the data. Dimension reduction using PCA with clustering
                        models is a powerful technique to reduce the
                        dimensionality of the data while improving the
                        clustering performance.
                      </p>
                    </div>
                  </div>
                  <div className="item">
                    <div className="products_slide">
                      <img src="assets/images/restaurant-revenue.png" alt="" />
                      <h3>
                        <span>E-Commerce Products Dataset</span>
                      </h3>
                      <p style={{ fontsize: 14 }}>
                        Record linkage is the process of linking records that
                        refer to the same entity or object across different data
                        sources. In the context of e-commerce products, record
                        linkage can be used to link product records from
                        different e-commerce platforms or retailers that refer
                        to the same product.
                      </p>
                    </div>
                  </div>
                  <div className="item">
                    <div className="products_slide">
                      <img src="assets/images/alI-chatbot.png" alt="" />
                      <h3>
                        <span>
                          Anomaly Detection with clustering Data Science
                        </span>
                      </h3>
                      <p style={{ fontsize: 14 }}>
                        Anomaly detection, particularly for fraud detection, can
                        be achieved using clustering techniques in data science.
                        The idea is to use clustering to group data points
                        together and identify any outliers or anomalies that do
                        not belong to any cluster.
                      </p>
                    </div>
                  </div>
                  <div className="item">
                    <div className="products_slide">
                      <img src="assets/images/alI-chatbot.png" alt="" />
                      <img src="assets/images/restaurant-revenue.png" alt="" />
                      <h3>
                        <span>
                          Likeness of Item B being purchased after item A
                          prediction
                        </span>
                      </h3>
                      <p style={{ fontsize: 14 }}>
                        Association rules mining is a technique used to find
                        patterns or relationships between items in a dataset. In
                        the context of e-commerce, association rules mining can
                        be used to find items that are frequently purchased
                        together, which can be used to make recommendations to
                        customers.
                      </p>
                    </div>
                  </div>
*/}
                </OwlCarousel>
              </div>
              <div id="tab014" className="tab-pane fade">
                <Projects id="3" />
                <OwlCarousel
                  className="owl-theme"
                  loop
                  margin={20}
                  nav
                  navText={[" ", " "]}
                  responsive={{
                    0: {
                      items: 1,
                    },
                    600: {
                      items: 1,
                    },
                    1000: {
                      items: 3,
                    },
                  }}
                >
                  <div className="item">
                    <div className="products_slide">
                      <img src="assets/images/face-detection.png" alt="" />
                      <h3>
                        <span>
                          Online Movie recommendation system to predict
                          preference
                        </span>
                      </h3>
                      <p style={{ fontsize: 14 }}>
                        Movie Recommendation system is a data science solution
                        that predicts the preferences of users for movies and
                        recommends relevant movies to them. The system uses
                        machine learning algorithms to analyze user data and
                        movie metadata to make predictions and recommendations.
                      </p>
                    </div>
                  </div>
                  <div className="item">
                    <div className="products_slide">
                      <img src="assets/images/alI-chatbot.png" alt="" />
                      <h3>
                        <span>Online Books recommendation System</span>
                      </h3>
                      <p style={{ fontsize: 14 }}>
                        Collaborative filtering popular approach to
                        recommendation systems.It involves analyzing the
                        behavior of similar users to predict what a user might
                        like. For example, if User A and User B both read and
                        liked similar books, the system might recommend a new
                        book to User A based on the assumption that they will
                        also like it
                      </p>
                    </div>
                  </div>
                  <div className="item">
                    <div className="products_slide">
                      <img src="assets/images/restaurant-revenue.png" alt="" />
                      <h3>
                        <span>Restaurant Revenue Prediction</span>
                      </h3>
                      <p style={{ fontsize: 14 }}>
                        One popular architecture for speech recognition is the
                        recurrent neural network (RNN), which can model the
                        temporal dependencies in speech.Use the preprocessed
                        data to train your neural network.
                      </p>
                    </div>
                  </div>
                  <div className="item">
                    <div className="products_slide">
                      <img src="assets/images/face-detection.png" alt="" />
                      <h3>
                        <span>Design chatGPT</span>
                      </h3>
                      <p style={{ fontsize: 14 }}>
                        Use ChatGPT deep learning techniques to generate
                        human-like responses to user inputs.ChatGPT uses a
                        variant of the transformer architecture called the
                        Generative Pre-trained Transformer (GPT). This
                        architecture allows the model to process sequences of
                        text and generate new text that is coherent and
                        grammatically correct
                      </p>
                    </div>
                  </div>
                </OwlCarousel>
              </div>
            </div>

           
          </div>
        </div>
      </section>

      <section ref={mentorSection} className="mentor" id="mentor">
        <div className="container">
          <br/><br/>
          <h2 style={{ fontSize: '32px', fontFamily: "'DM Serif Display', serif" }}><b> Who will <b style={{fontFamily: "'DM Serif Display', serif", color:"#9769ef" }}>teach</b> Full Stack Development?
          </b></h2><br/>

          <MentorsProfile ytUrl="https://www.youtube.com/embed/1F4UdunhTco"/>
          <div className="review_scroll_sec">
            <div className="review_scroll_inner">


              <div className="faculty-box position-relative d-flex flex-column">

                <div className="body">
                  <h3 className="name">Suvom Shaw</h3>
                  <p className="title">
                    Senior AI Architect at Samsung R & D Division
                  </p>
                  <p className="description">
                    Instructor & mentor (AI & ML) — LogicMojo AI Candidate cohort guidance.
                  </p>
                </div>

                <footer className="d-flex position-relative justify-content-start align-items-center">
                  <img src="assets/images/amazonicon.png" />
                  <img
                    className="faculty-img position-absolute"
                    src="https://logicmojo.com/assets/dist/new_index_design/images/GithubJan26/Suvom.jpg"
                  />
                  <a
                    className="inline-block linkedin-icon position-absolute"
                    href="https://www.linkedin.com/in/suvomshaw/"
                  >
                    <svg
                      stroke="currentColor"
                      fill="currentColor"
                      stroke-width="0"
                      viewBox="0 0 16 16"
                      class="bg-white text-[#0077B6]"
                      height="18"
                      width="18"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854V1.146zm4.943 12.248V6.169H2.542v7.225h2.401zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248-.822 0-1.359.54-1.359 1.248 0 .694.521 1.248 1.327 1.248h.016zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016a5.54 5.54 0 0 1 .016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225h2.4z"></path>
                    </svg>
                  </a>
                </footer>
              </div>


            
              <div className="faculty-box position-relative d-flex flex-column">

                <div className="body">
                  <h3 className="name">Aman kumar</h3>
                  <p className="title">
                    Senior Full Stack Developer Mentor
                  </p>
                  <p className="description">
                    Aman working as R & D Group of WalmartLabs as senior full stack Developer.
                  </p>
                </div>

                <footer className="d-flex position-relative justify-content-start align-items-center">
                  <img src="assets/images/walmarticon.png" />
                  <img
                    className="faculty-img position-absolute"
                    src="assets/images/Aman.jpg"
                  />
                  <a
                    className="inline-block linkedin-icon position-absolute"
                    href="https://www.linkedin.com/in/aman-kumar-coder/"
                  >
                    <svg
                      stroke="currentColor"
                      fill="currentColor"
                      stroke-width="0"
                      viewBox="0 0 16 16"
                      class="bg-white text-[#0077B6]"
                      height="18"
                      width="18"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854V1.146zm4.943 12.248V6.169H2.542v7.225h2.401zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248-.822 0-1.359.54-1.359 1.248 0 .694.521 1.248 1.327 1.248h.016zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016a5.54 5.54 0 0 1 .016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225h2.4z"></path>
                    </svg>
                  </a>
                </footer>
              </div>

              <div className="faculty-box position-relative d-flex flex-column">

                <div className="body">
                  <h3 className="name">Ravi Singh</h3>
                  <p className="title">
                    Technical Architect at WalmartLabs
                  </p>
                  <p className="description">
                    Ravi has been part of multiple companies, Amazon as well as WalmartLabs. His background involves handling 
System architecture and design in full stack based projects.
                  </p>
                </div>

                <footer className="d-flex position-relative justify-content-start align-items-center">
                  <img src="assets/images/walmarticon.png" />
                  <img
                    className="faculty-img position-absolute"
                    src="assets/images/mac/ravi-singh.jpg"
                  />
                  <a
                    className="inline-block linkedin-icon position-absolute"
                    href="https://www.linkedin.com/in/ravi-singh-a430ab29/"
                  >
                    <svg
                      stroke="currentColor"
                      fill="currentColor"
                      stroke-width="0"
                      viewBox="0 0 16 16"
                      class="bg-white text-[#0077B6]"
                      height="18"
                      width="18"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854V1.146zm4.943 12.248V6.169H2.542v7.225h2.401zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248-.822 0-1.359.54-1.359 1.248 0 .694.521 1.248 1.327 1.248h.016zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016a5.54 5.54 0 0 1 .016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225h2.4z"></path>
                    </svg>
                  </a>
                </footer>
              </div>


              <div className="faculty-box position-relative d-flex flex-column">

                <div className="body">
                  <h3 className="name">Vishal Gupta</h3>
                  <p className="title">
                    Senior Software Engineer, Walmart Global Tech India
                  </p>
                  <p className="description">
                     Vishal is a senior instructor who teaches backend systems and architecture in full stack development. 
Under his leadership, all candidates will complete 5+ projects on full stack development during the classes.

                  </p>
                </div>

                <footer className="d-flex position-relative justify-content-start align-items-center">
                  <img src="assets/images/walmarticon.png" />
                  <img
                    className="faculty-img position-absolute"
                    src="assets/images/mac/vishal.jpg"
                  />
                  <a
                    className="inline-block linkedin-icon position-absolute"
                    href="https://www.linkedin.com/in/connect-vishal-gupta/"
                  >
                    <svg
                      stroke="currentColor"
                      fill="currentColor"
                      stroke-width="0"
                      viewBox="0 0 16 16"
                      class="bg-white text-[#0077B6]"
                      height="18"
                      width="18"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854V1.146zm4.943 12.248V6.169H2.542v7.225h2.401zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248-.822 0-1.359.54-1.359 1.248 0 .694.521 1.248 1.327 1.248h.016zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016a5.54 5.54 0 0 1 .016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225h2.4z"></path>
                    </svg>
                  </a>
                </footer>
              </div>


            </div>
          </div>
          {/* <div className="owl-carousel owl-theme with-nav">
            <div className="item">
              <div className="faculty-box">
                <div className="faculty-img">
                  <img src="https://logicmojo.com/assets/dist/new_index_design/images/GithubJan26/Suvom.jpg" />
                </div>

                <h3 className="name">Suvom Shaw</h3>
                <p className="title">Senior AI Architect at Samsung R & D Division</p>
                <p className="title">Instructor & Mentor (AI & ML)</p>
                <p className="description">
                  Instructor & mentor (AI & ML) — LogicMojo AI Candidate cohort guidance.
                </p>
                <p>Instructor Profile : <a target="_blank" href="https://www.linkedin.com/in/suvomshaw/">Linkedin</a></p>
              </div>
            </div>

            <div className="item">
              <div className="faculty-box">



                <div className="faculty-img">
                  <img src="assets/images/aman.jpg" />
                </div>

                <h3 className="name">Aman kumar</h3>
                <p className="title">Senior Full Stack Developer Mentor </p>
                <p className="title">SDE3 at WalmartLabs</p>
                <p className="description">
                  Aman working as R & D Group of WalmartLabs as senior full stack Developer.
                </p>
                <p>Instructor Profile : <a target="_blank" href="https://www.linkedin.com/in/aman-kumar-coder/">Linkedin</a></p>


              </div>
            </div>

            <div className="item">
              <div className="faculty-box">
                <div className="faculty-img">
                  <img src="assets/images/mac/ravi-singh.jpg" />
                </div>

                <h3 className="name">Ravi Singh</h3>
                <p className="title">Technical Architect at WalmartLabs</p>
                <p className="description">
                  Ravi has been part of multiple companies, Amazon as well as WalmartLabs. His background involves handling
                  System architecture and design in full stack based projects.
                </p>
                <p>Instructor Profile : <a target="_blank" href="https://www.linkedin.com/in/ravi-singh-a430ab29/">Linkedin</a></p>
              </div>
            </div>
            <div className="item">
              <div className="faculty-box">
                <div className="faculty-img">
                  <img src="assets/images/mac/vishal.jpg" />
                </div>

                <h3 className="name">Vishal Gupta</h3>
                <p className="title">Senior Software Engineer, Walmart Global Tech India</p>
                <p className="description">
                  Vishal is a senior instructor who teaches backend systems and architecture in full stack development.
                  Under his leadership, all candidates will complete 5+ projects on full stack development during the classes.
                </p>
                <p>Instructor Profile : <a target="_blank" href="https://www.linkedin.com/in/connect-vishal-gupta/">Linkedin</a></p>
              </div>
            </div>





          </div> */}

        </div>
      </section>

      
    
      <section ref={placementSection} className="careerservices-new" id="placement">
      <div className="container clearfix">
        <CareerServices />
        </div>
        </section>
        
      <ComparisonWithOther />

    
        <section className="careeroppbg" >
          <center>
            <div style={{ paddingLeft: 10 + "px" }}>
              <a
                target="_default"
                href="https://calendly.com/logicmojo/30min"
                className="btn btn-danger secondmenu_btn"
              >
                <b>Apply For Live Classes</b>
              </a>
            </div>
          </center>
        </section>


      <section ref={feeSection}  className="howtoapply-new" id="fee">
        <div className="container">
        <h2 style={{ fontSize: '32px', fontFamily: "'DM Serif Display', serif" }}><b>How to Register For Logicmojo</b><b style={{fontFamily: "'DM Serif Display', serif", color:"#9769ef" }}> Full Stack Developer Course? </b></h2><br/>
         
          <div className="row">
            <div className="col-lg-8">
              <div className="howtoapply-new-left">
                <ul>
                  <li>
                    <h4>Step 1</h4>
                    <h3>Submit Application</h3>
                    <p>Book calender call with our senior Software Developer</p>
                  </li>
                  <li>
                    <h4>Step 2</h4>
                    <h3>Application Review</h3>
                    <p>
                      Senior Developer will review your profile & answer all your
                      queries
                    </p>
                  </li>
                  <li>
                    <h4>Step 3</h4>
                    <h3>Admission</h3>
                    <p>
                      Candidate can apply for Online Live classes for 7 months
                    </p>
                  </li>
                </ul>
              </div>
            </div>

            <div className="col-lg-4">
              <div className="howtoapply-new-right">
               
                <div className="howtoapply-new-rightform">
                  <form>
                    <div className="row">
                      <div className="form-group col-lg-12">
                        <input
                          type="submit"
                          className="submitbtn"
                          value="Apply For Live Classes"
                        />
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>



      <div className="eligibility-criteria-row" >
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <div className="eligibility-criteria">
                <h3 style={{ fontSize: 25 }}>Eligibility Criteria</h3>
                <ul className="eligibilitylist1">
                  <li>
                    <span>
                      <img
                        src="assets/images/eligibilitylist1-icon1.png"
                        alt=""
                      />
                    </span>
                    A bechelor's degree with an average of 50% or higher marks
                  </li>
                  <li>
                    <span>
                      <img
                        src="assets/images/eligibilitylist1-icon2.png"
                        alt=""
                      />
                    </span>
                    Basic understanding of programming concepts and mathematics
                  </li>
                  <li>
                    <span>
                      <img
                        src="assets/images/eligibilitylist1-icon3.png"
                        alt=""
                      />
                    </span>
                    Working experience preferred
                  </li>
                </ul>
              </div>
            </div>

            <div className="col-md-6">
              <div className="eligibility-criteria">
                <h3 style={{ fontSize: 25 }} >Who can apply for the Full Stack Developer course?</h3>
                <ul className="eligibilitylist2">
                  <li>Software engineers</li>
                  <li>IT Professionals</li>
                  <li>Data Professionals</li>
                  <li>Business Analysis</li>
                  <li>Product Managers</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <br />
      <section ref={feeSection} className="programfeenew" id="fee">
          <div className="container">
          <h2 style={{ fontSize: '32px', fontFamily: "'DM Serif Display', serif" }}><b>Course</b><b style={{fontFamily: "'DM Serif Display', serif", color:"#9769ef" }}> Fee ? </b></h2><br/>
          
            <div className="programfeenew-inner">
              <div className="programfeenew-inner-left">
                <div className="programfeenew-inner-price">
                  <p>Total Fee</p>
                  <h3>₹ 54,000</h3>
                </div>
              </div>
              <div className="programfeenew-inner-right">
                <h5>No Cost EMI</h5>
                <div className="d-flex align-items-center justify-content-between">
                  <h4>
                    <span>As low as</span> ₹ 5,160/month
                  </h4>
                  <a
                    target="_default"
                    href="https://calendly.com/logicmojo/30min"
                  >
                    Apply now
                  </a>
                </div>
                <p>
                  We have partnered with the following financing companies to
                  provide competitive finance options at 0% interest rate with no
                  hidden costs...
                </p>
                <ul>
                  <li>
                    <img src="assets/images/feelogo1.png" alt="" />
                  </li>
                  <li>
                    <img src="assets/images/feelogo2.png" alt="" />
                  </li>
                  <li>
                    <img src="assets/images/feelogo3.png" alt="" />
                  </li>
                  <li>
                    <img src="assets/images/feelogo4.png" alt="" />
                  </li>
                  <li>
                    <img src="assets/images/feelogo5.png" alt="" />
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>
     

      
      

     

      <section className="careeroppbg">
        <center>
          <div style={{ paddingLeft: 10 + "px" }}>
            <a
              target="_default"
              href="https://calendly.com/logicmojo/30min"
              className="btn btn-danger secondmenu_btn"
            >
              <b>Apply For Live Classes</b>
            </a>
          </div>
        </center>
      </section>


      {/*
      <section className="relatedcourses">
        <div className="container">
          <h2 style={{ fontSize: 25 }}>Full Stack Developer Course Faculty</h2>
          <div className="owl-carousel owl-theme with-nav">
            

            

            
          </div>
        </div>
      </section>
                    */}


      {/*
      <section id="relatedcourses" className="relatedcourses">
        <div className="container">
          <h2>Full Stack Developer Blogs</h2>
          <div className="owl-carousel owl-theme with-nav">
            <div className="item">
              <div className="relatedcoursebox">
                <Link
                  target="_default"
                  to="https://logicmojo.com/data-science-interview-questions"
                >
                  <img src="assets/images/data-science-interview.jpeg" alt="" />
                </Link>
                <div className="relatedcoursebox-content">
                  <h3>Data Science Interview Questions</h3>
                </div>
              </div>
            </div>

            <div className="item">
              <div className="relatedcoursebox">
                <Link
                  target="_default"
                  to="https://logicmojo.com/data-science-introduction"
                >
                  <img
                    src="assets/images/mac/what-is-data-science-Intro.jpg"
                    alt=""
                  />
                </Link>
                <div className="relatedcoursebox-content">
                  <h3>Introduction : What is Data Science</h3>
                </div>
              </div>
            </div>

            <div className="item">
              <div className="relatedcoursebox">
                <Link
                  target="_default"
                  to="https://logicmojo.com/machine-learning-interview-questions"
                >
                  <img
                    src="assets/images/mac/machine-learning-interview-question.jpg"
                    alt=""
                  />
                </Link>
                <div className="relatedcoursebox-content">
                  <h3>Machine Learning Interview Questions</h3>
                </div>
              </div>
            </div>

            <div className="item">
              <div className="relatedcoursebox">
                <Link
                  target="_default"
                  to="https://logicmojo.com/data-scientist-salary"
                >
                  <img
                    src="assets/images/mac/Data-Scientist-Salary.jpg"
                    alt=""
                  />
                </Link>
                <div className="relatedcoursebox-content">
                  <h3>What is Data Scientist Salary in India</h3>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
                              */}
      {/*
      <section id="relatedcourses" className="relatedcourses">
        <div className="container">
          <h2>Related Full Stack Developer Courses</h2>
          <div className="owl-carousel owl-theme with-nav">
            <div className="item">
              <div className="relatedcoursebox">
                <Link to="/Advance-Data-Science-ML-Program">
                  <img
                    src="assets/images/resources/advance_data_Science_program.jpg"
                    alt=""
                  />
                </Link>
                <div className="relatedcoursebox-content">
                  <h3 style={{ fontSize: 15 }}>
                    Advance Full Stacl Development Program
                  </h3>
                  <p>
                    <span className="starlable">
                      4.8 <i className="fa fa-star" aria-hidden="true"></i>
                    </span>
                    <span>5096 Learners</span>
                  </p>
                </div>
              </div>
            </div>

            <div className="item">
              <div className="relatedcoursebox">
                <Link to="/Advance-AI-ML-program">
                  <img
                    src="assets/images/resources/advance_ai_ml_program.jpg"
                    alt=""
                  />
                </Link>

                <div className="relatedcoursebox-content">
                  <h3 style={{ fontSize: 15 }}>Advance AI & ML Program </h3>
                  <p>
                    <span className="starlable">
                      4.8 <i className="fa fa-star" aria-hidden="true"></i>
                    </span>
                    <span>8976 Learners</span>
                  </p>
                </div>
              </div>
            </div>

            <div className="item">
              <div className="relatedcoursebox">
                <Link to="/master-data-Science-ai-program">
                  <img
                    src="assets/images/resources/data_science_master_program.jpg"
                    alt=""
                  />
                </Link>
                <div className="relatedcoursebox-content">
                  <h3 style={{ fontSize: 15 }}>
                    Big Data & Data Science Program
                  </h3>
                  <p>
                    <span className="starlable">
                      4.8 <i className="fa fa-star" aria-hidden="true"></i>
                    </span>
                    <span>10022 Learners</span>
                  </p>
                </div>
              </div>
            </div>
            <div className="item">
              <div className="relatedcoursebox">
                <Link to="/Data-Science-For-Freshers">
                  <img
                    src="assets/images/resources/Data-Science-Fundamental.jpg"
                    alt=""
                  />
                </Link>
                <div className="relatedcoursebox-content">
                  <h3 style={{ fontSize: 15 }}>
                    Data Science Course For Freshers
                  </h3>
                  <p>
                    <span className="starlable">
                      4.8 <i className="fa fa-star" aria-hidden="true"></i>
                    </span>
                    <span>986 Learners</span>
                  </p>
                </div>
              </div>
            </div>

            <div className="item">
              <div className="relatedcoursebox">
                <Link to="/Data-Science-Course-For-Managers">
                  <img
                    src="assets/images/resources/data-Science-for-Managers.jpg"
                    alt=""
                  />
                </Link>
                <div className="relatedcoursebox-content">
                  <h3 style={{ fontSize: 15 }}>
                    Data Science Course For Managers
                  </h3>
                  <p>
                    <span className="starlable">
                      4.8 <i className="fa fa-star" aria-hidden="true"></i>
                    </span>
                    <span>1786 Learners</span>
                  </p>
                </div>
              </div>
            </div>

            <div className="item">
              <div className="relatedcoursebox">
                <Link to="/Practical-Decision-Making-in-Data-Science">
                  <img
                    src="assets/images/resources/Data-Science-Freshers.jpg"
                    alt=""
                  />
                </Link>
                <div className="relatedcoursebox-content">
                  <h3 style={{ fontSize: 15 }}>AI Fundamental Course</h3>
                  <p>
                    <span className="starlable">
                      4.8 <i className="fa fa-star" aria-hidden="true"></i>
                    </span>
                    <span>1586 Learners</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
                            */}
      {
  /*
      <section className="city-section">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 master-page-city-wrapper">
              <h4>
                <strong>
                  Find Data Science Course Training in Other Regions
                </strong>
              </h4>
              <div className="city-link-container">
                <Link
                  title="Data Science Course in Pune"
                  to="/Data-Science-Course-in-Pune"
                >
                  Pune
                </Link>
                <Link
                  title="Data Science Course in Bangalore"
                  to="/Data-Science-Course-in-bangalore"
                >
                  Bangalore
                </Link>
                <Link
                  title="Data Science Course in Ahmedabad"
                  to="/Data-Science-Course-Ahmedabad"
                >
                  Ahmedabad
                </Link>
                <Link
                  title="Data Science Course in Bhilai"
                  to="/Data-Science-Course-Bhilai"
                >
                  Bhilai
                </Link>
                <Link
                  title="Data Science Course in Bhopal"
                  to="/Data-Science-Course-Bhopal"
                >
                  Bhopal
                </Link>
                <Link
                  title="Data Science Course in Bhubaneshwar"
                  to="/Data-Science-Course-Bhubaneshwar"
                >
                  Bhubaneshwar
                </Link>
                <Link
                  title="Data Science Course in Boston"
                  to="/Data-Science-Course-Boston"
                >
                  Boston
                </Link>
                <Link
                  title="Data Science Course in Chandigarh"
                  to="/Data-Science-Course-Chandigarh"
                >
                  Chandigarh
                </Link>
                <Link
                  title="Data Science Course in Chennai"
                  to="/Data-Science-Course-Chennai"
                >
                  Chennai
                </Link>
                <Link
                  title="Data Science Course in Chicago"
                  to="/Data-Science-Course-Chicago"
                >
                  Chicago
                </Link>
                <Link
                  title="Data Science Course in Cochin"
                  to="/Data-Science-Course-Cochin"
                >
                  Cochin
                </Link>
                <Link
                  title="Data Science Course in Coimbatore"
                  to="/Data-Science-Course-Coimbatore"
                >
                  Coimbatore
                </Link>
                <Link
                  title="Data Science Course in Dallas"
                  to="/Data-Science-Course-Dallas"
                >
                  Dallas
                </Link>
                <Link
                  title="Data Science Course in Dehradun"
                  to="/Data-Science-Course-Dehradun"
                >
                  Dehradun
                </Link>
                <Link
                  title="Data Science Course in Delhi"
                  to="/Data-Science-Course-Delhi"
                >
                  Delhi
                </Link>
                <Link
                  title="Data Science Course in Dubai"
                  to="/Data-Science-Course-Dubai"
                >
                  Dubai
                </Link>
                <Link
                  title="Data Science Course in Durban"
                  to="/Data-Science-Course-Durban"
                >
                  Durban
                </Link>
                <Link
                  title="Data Science Course in Faridabad"
                  to="/Data-Science-Course-Faridabad"
                >
                  Faridabad
                </Link>
                <Link
                  title="Data Science Course in Ghaziabad"
                  to="/Data-Science-Course-Ghaziabad"
                >
                  Ghaziabad
                </Link>
                <Link
                  title="Data Science Course in Guntur"
                  to="/Data-Science-Course-Guntur"
                >
                  Guntur
                </Link>
                <Link
                  title="Data Science Course in Gurgaon"
                  to="/Data-Science-Course-Gurgaon"
                >
                  Gurgaon
                </Link>
                <Link
                  title="Data Science Course in Guwahati"
                  to="/Data-Science-Course-Guwahati"
                >
                  Guwahati
                </Link>
                <Link
                  title="Data Science Course in HongKong"
                  to="/Data-Science-Course-HongKong"
                >
                  HongKong
                </Link>
                <Link
                  title="Data Science Course in Hyderabad"
                  to="/Data-Science-Course-Hyderabad"
                >
                  Hyderabad
                </Link>
                <Link
                  title="Data Science Course in Jaipur"
                  to="/Data-Science-Course-Jaipur"
                >
                  Jaipur
                </Link>
                <Link
                  title="Data Science Course in Johannesburg"
                  to="/Data-Science-Course-Johannesburg"
                >
                  Johannesburg
                </Link>
                <Link
                  title="Data Science Course in Los Kanpur"
                  to="/Data-Science-Course-Kanpur"
                >
                  Kanpur
                </Link>
                <Link
                  title="Data Science Course in Khammam"
                  to="/Data-Science-Course-Khammam"
                >
                  Khammam
                </Link>
                <Link
                  title="Data Science Course in Kolkata"
                  to="/Data-Science-Course-Kolkata"
                >
                  Kolkata
                </Link>
                <Link
                  title="Data Science Course in LosAngeles"
                  to="/Data-Science-Course-LosAngeles"
                >
                  LosAngeles
                </Link>
                <Link
                  title="Data Science Course in Lucknow"
                  to="/Data-Science-Course-Lucknow"
                >
                  Lucknow
                </Link>
                <Link
                  title="Data Science Course in Madurai"
                  to="/Data-Science-Course-Madurai"
                >
                  Madurai
                </Link>
                <Link
                  title="Data Science Course in Miami"
                  to="/Data-Science-Course-Miami"
                >
                  Miami
                </Link>
                <Link
                  title="Data Science Course in Mumbai"
                  to="/Data-Science-Course-Mumbai"
                >
                  Mumbai
                </Link>
                <Link
                  title="Data Science Course in Mysore"
                  to="/Data-Science-Course-Mysore"
                >
                  Mysore
                </Link>
                <Link
                  title="Data Science Course in Nagpur"
                  to="/Data-Science-Course-Nagpur"
                >
                  Nagpur
                </Link>
                <Link
                  title="Data Science Course in Noida"
                  to="/Data-Science-Course-Noida"
                >
                  Noida
                </Link>
                <Link
                  title="Data Science Course in Patna"
                  to="/Data-Science-Course-Patna"
                >
                  Patna
                </Link>
                <Link
                  title="Data Science Course in Pondicherry"
                  to="/Data-Science-Course-Pondicherry"
                >
                  Pondicherry
                </Link>
                <Link
                  title="Data Science Course in Ranchi"
                  to="/Data-Science-Course-Ranchi"
                >
                  Ranchi
                </Link>
                <Link
                  title="Data Science Course in Seattle"
                  to="/Data-Science-Course-Seattle"
                >
                  Seattle
                </Link>
                <Link
                  title="Data Science Course in Shimoga"
                  to="/Data-Science-Course-Shimoga"
                >
                  Shimoga
                </Link>
                <Link
                  title="Data Science Course in Surat"
                  to="/Data-Science-Course-Surat"
                >
                  Surat
                </Link>
                <Link
                  title="Data Science Course in Thane"
                  to="/Data-Science-Course-Thane"
                >
                  Thane
                </Link>
                <Link
                  title="Data Science Course in Thiruvananthapuram"
                  to="/Data-Science-Course-Thiruvananthapuram"
                >
                  Thiruvananthapuram
                </Link>
                <Link
                  title="Data Science Course in Tiruchchirappalli"
                  to="/Data-Science-Course-Tiruchchirappalli"
                >
                  Tiruchchirappalli
                </Link>
                <Link
                  title="Data Science Course in Tirupati"
                  to="/Data-Science-Course-Tirupati"
                >
                  Tirupati
                </Link>
                <Link
                  title="Data Science Course in Toronto"
                  to="/Data-Science-Course-Toronto"
                >
                  Toronto
                </Link>
                <Link
                  title="Data Science Course in Trichur"
                  to="/Data-Science-Course-Trichur"
                >
                  Trichur
                </Link>
                <Link
                  title="Data Science Course in Vadodara"
                  to="/Data-Science-Course-Vadodara"
                >
                  Vadodara
                </Link>
                <Link
                  title="Data Science Course in Visakhapatnam"
                  to="/Data-Science-Course-Visakhapatnam"
                >
                  Visakhapatnam
                </Link>
                <Link
                  title="Data Science Course in Warangal"
                  to="/Data-Science-Course-Warangal"
                >
                  Warangal
                </Link>
                <Link
                  title="Data Science Course in Washington"
                  to="/Data-Science-Course-Washington"
                >
                  Washington
                </Link>
                <Link
                  title="Data Science Course in Mountain View"
                  to="/Data-Science-Course-MountainView"
                >
                  Mountain View
                </Link>
                <Link
                  title="Data Science Course in Ashburn"
                  to="/Data-Science-Course-Ashburn"
                >
                  Ashburn
                </Link>
                <Link
                  title="Data Science Course in Charlotte"
                  to="/Data-Science-Course-Charlotte"
                >
                  Charlotte
                </Link>
                <Link
                  title="Data Science Course in Austin"
                  to="/Data-Science-Course-Austin"
                >
                  Austin
                </Link>
                <Link
                  title="Data Science Course in San Diego"
                  to="/Data-Science-Course-SanDiego"
                >
                  San Diego
                </Link>
                <Link
                  title="Data Science Course in Irving"
                  to="/Data-Science-Course-Irving"
                >
                  Irving
                </Link>
                <Link
                  title="Data Science Course in Columbus"
                  to="/Data-Science-Course-Columbus"
                >
                  Columbus
                </Link>
                <Link
                  title="Data Science Course in Sunnyvale"
                  to="/Data-Science-Course-Sunnyvale"
                >
                  Sunnyvale
                </Link>
                <Link
                  title="Data Science Course in Fremont"
                  to="/Data-Science-Course-Fremont"
                >
                  Fremont
                </Link>
                <Link
                  title="Data Science Course in Denver"
                  to="/Data-Science-Course-Denver"
                >
                  Denver
                </Link>
                <Link
                  title="Data Science Course in Philadelphia"
                  to="/Data-Science-Course-Philadelphia"
                >
                  Philadelphia
                </Link>
                <Link
                  title="Data Science Course in Vijayawada"
                  to="/Data-Science-Course-Vijayawada"
                >
                  Vijayawada
                </Link>
                <Link
                  title="Data Science Course in Ireland"
                  to="/Data-Science-Course-Ireland"
                >
                  Ireland
                </Link>

                <Link
                  title="Data Science Course in Jamshedpur"
                  to="/Data-Science-Course-Jamshedpur"
                >
                  Jamshedpur
                </Link>
                <Link
                  title="Data Science Course in Kerala"
                  to="/Data-Science-Course-Kerala"
                >
                  Kerala
                </Link>
                <Link
                  title="Data Science Course in TamilNadu"
                  to="/Data-Science-Course-TamilNadu"
                >
                  TamilNadu
                </Link>

                <Link
                  title="Data Science Course in AbuDhabi"
                  to="/Data-Science-Course-AbuDhabi"
                >
                  AbuDhabi
                </Link>
                <Link
                  title="Data Science Course in Ludhiana"
                  to="/Data-Science-Course-Ludhiana"
                >
                  Ludhiana
                </Link>
                <Link
                  title="Data Science Course in Ernakulam"
                  to="/Data-Science-Course-Ernakulam"
                >
                  Ernakulam
                </Link>
                <Link
                  title="Data Science Course in Kottayam"
                  to="/Data-Science-Course-Kottayam"
                >
                  Kottayam
                </Link>
                <Link
                  title="Data Science Course in Khammam"
                  to="/Data-Science-Course-Khammam"
                >
                  Khammam
                </Link>
                <Link
                  title="Data Science Course in Jacksonville"
                  to="/Data-Science-Course-Jacksonville"
                >
                  Jacksonville
                </Link>
                <Link
                  title="Data Science Course in Newark"
                  to="/Data-Science-Course-Newark"
                >
                  Newark
                </Link>
                <Link
                  title="Data Science Course in Pittsburgh"
                  to="/Data-Science-Course-Pittsburgh"
                >
                  Pittsburgh
                </Link>
                <Link
                  title="Data Science Course in Raleigh"
                  to="/Data-Science-Course-Raleigh"
                >
                  Raleigh
                </Link>
                <Link
                  title="Data Science Course in Salem"
                  to="/Data-Science-Course-Salem"
                >
                  Salem
                </Link>
                <Link
                  title="Data Science Course in Sarasota"
                  to="/Data-Science-Course-Sarasota"
                >
                  Sarasota
                </Link>
                <Link
                  title="Data Science Course in Tacoma"
                  to="/Data-Science-Course-Tacoma"
                >
                  Tacoma
                </Link>
                <Link
                  title="Data Science Course in Tampa"
                  to="/Data-Science-Course-Tampa"
                >
                  Tampa
                </Link>
                <Link
                  title="Data Science Course in Abuja"
                  to="/Data-Science-Course-Abuja"
                >
                  Abuja
                </Link>
                <Link
                  title="Data Science Course in Lagos"
                  to="/Data-Science-Course-Lagos"
                >
                  Lagos
                </Link>
                <Link
                  title="Data Science Course in Manila"
                  to="/Data-Science-Course-Manila"
                >
                  Manila
                </Link>
                <Link
                  title="Data Science Course in CapeTown"
                  to="/Data-Science-Course-CapeTown"
                >
                  CapeTown
                </Link>
                <Link
                  title="Data Science Course in Calgary"
                  to="/Data-Science-Course-Calgary"
                >
                  Calgary
                </Link>
                <Link
                  title="Data Science Course in Montreal"
                  to="/Data-Science-Course-Montreal"
                >
                  Montreal
                </Link>
                <Link
                  title="Data Science Course in Vancouver"
                  to="/Data-Science-Course-Vancouver"
                >
                  Vancouver
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
*/}

     

     

      <section id="relatedcourses" className="relatedcourses">
        <div className="container ">
        <h2 style={{ fontSize: '32px', fontFamily: "'DM Serif Display', serif" }}><b>Blogs Related to Full Stack Developer Course</b></h2>
          <div className="owl-carousel owl-theme with-nav">
            <div className="item">
              <div className="relatedcoursebox">
                <Link
                  target="_default"
                  to="https://logicmojo.com/full-stack-developer"
                >
                  <img src="assets/images/full-stack1.png" style={{ width: 500, height: 250 }} alt="" />
                </Link>
                <div className="relatedcoursebox-content">
                  <h3>What is Full Stack Developer</h3>
                </div>
              </div>
            </div>

            <div className="item">
              <div className="relatedcoursebox">
                <Link
                  target="_default"
                  to="https://logicmojo.com/full-stack-developer-salary"
                >
                  <img
                    src="assets/images/FS-salary-intro.jpeg" style={{ width: 500, height: 250 }}
                    alt=""
                  />
                </Link>
                <div className="relatedcoursebox-content">
                  <h3>Full Stack Developer Salary</h3>
                </div>
              </div>
            </div>

            <div className="item">
              <div className="relatedcoursebox">
                <Link
                  target="_default"
                  to="https://logicmojo.com/javascript-interview-questions"
                >
                  <img
                    src="assets/images/javascript-interview.jpeg" style={{ width: 500, height: 250 }}
                    alt=""
                  />
                </Link>
                <div className="relatedcoursebox-content">
                  <h3>JavaScript Interview Questions</h3>
                </div>
              </div>
            </div>

            <div className="item">
              <div className="relatedcoursebox">
                <Link
                  target="_default"
                  to="https://logicmojo.com/spring-boot-interview-questions"
                >
                  <img
                    src="assets/images/spring-Boot.jpg"
                    alt=""
                  />
                </Link>
                <div className="relatedcoursebox-content">
                  <h3>Spring Boot Interview Questions</h3>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/*
      <section id="relatedcourses" className="relatedcourses">
        <div className="container ">
          <h3>Related Full Stack Developer Course</h3>
          <div className="owl-carousel owl-theme with-nav">
            <div className="item">
              <div className="relatedcoursebox">
                <Link to="/Full-Stack-Developer-For-Managers">
                  <img
                    src="assets/images/resources/advance_data_Science_program.jpg"
                    alt=""
                  />
                </Link>
                <div className="relatedcoursebox-content">
                  <h3 style={{ fontSize: 15 }}>
                    Full Stack Developer For Managers
                  </h3>
                  <p>
                    <span className="starlable">
                      4.8 <i className="fa fa-star" aria-hidden="true"></i>
                    </span>
                    <span>3095 Learners</span>
                  </p>
                </div>
              </div>
            </div>

            <div className="item">
              <div className="relatedcoursebox">
                <Link to="/Full-Stack-Developer-For-Undergraduate">
                  <img
                    src="assets/images/resources/advance_ai_ml_program.jpg"
                    alt=""
                  />
                </Link>

                <div className="relatedcoursebox-content">
                  <h3 style={{ fontSize: 15 }}>Full Stack Developer For Undergraduate </h3>
                  <p>
                    <span className="starlable">
                      4.8 <i className="fa fa-star" aria-hidden="true"></i>
                    </span>
                    <span>8976 Learners</span>
                  </p>
                </div>
              </div>
            </div>

            <div className="item">
              <div className="relatedcoursebox">
                <Link to="/MEAN-Stack-Full-Stack-Developers-Course">
                  <img
                    src="assets/images/resources/data_science_master_program.jpg"
                    alt=""
                  />
                </Link>
                <div className="relatedcoursebox-content">
                  <h3 style={{ fontSize: 15 }}>
                    MEAN Stack Full Stack Developers Course
                  </h3>
                  <p>
                    <span className="starlable">
                      4.8 <i className="fa fa-star" aria-hidden="true"></i>
                    </span>
                    <span>10022 Learners</span>
                  </p>
                </div>
              </div>
            </div>
            <div className="item">
              <div className="relatedcoursebox">
                <Link to="/MERN-Stack-For-Beginners">
                  <img
                    src="assets/images/resources/Data-Science-Fundamental.jpg"
                    alt=""
                  />
                </Link>
                <div className="relatedcoursebox-content">
                  <h3 style={{ fontSize: 15 }}>
                    MERN Stack For Beginners
                  </h3>
                  <p>
                    <span className="starlable">
                      4.8 <i className="fa fa-star" aria-hidden="true"></i>
                    </span>
                    <span>986 Learners</span>
                  </p>
                </div>
              </div>
            </div>




          </div>
        </div>
      </section>
*/}
      <section  ref={faqSection}id="faq" className="faqnewbg py-0">
        <div className="container">
        <h2 style={{ fontSize: '32px', fontFamily: "'DM Serif Display', serif" }}><b>
            Frequently Asked Questions (FAQs)
            </b></h2>
          <div className="faqnewbg-inner">
            <div className="faqnew">
              <div className="accordion" id="accordionExample2">
                <div className="card">
                  <div className="card-header" id="heading00">
                    <h3 className="mb-0">
                      <button
                        type="button"
                        className="btn btn-link collapsed"
                        data-toggle="collapse"
                        data-target="#collapse00"
                        aria-expanded="false"
                      >
                        <i className="fa fa-angle-down"></i> What is Logicmojo's
                        " Master full-stack Web development Course"?
                      </button>
                    </h3>
                  </div>

                  <div
                    id="collapse00"
                    className="collapse"
                    aria-labelledby="heading00"
                    data-parent="#accordionExample2"
                  >
                    <div className="card-body">
                      <p>
                        <b>
                          Logicmojo's "Master Full-Stack Developer Course"
                          is a comprehensive and career-accelerating program
                          designed for software engineers. This course is open
                          to software engineers of all experience levels,
                          regardless of the number of years they've worked or
                          their current employment status. Here are the key
                          features and highlights of this program:
                        </b>
                      </p>
                      <ul>
                        <li>
                          <b>Structured Curriculum:</b> The course curriculum is
                          meticulously designed to cover Computer Science
                          fundamentals and System Design through a project-based
                          approach. It's carefully crafted and vetted by
                          industry experts, ensuring that you gain the skills
                          needed to excel as a top-tier engineer.
                        </li>

                        <li>
                          <b>Live Classes:</b> You'll have the opportunity to
                          participate in live classes, which are conducted twice
                          a week. The exact timings for these classes are
                          determined based on the convenience of the students in
                          your batch.
                        </li>

                        <li>
                          <b>Experienced Tutors:</b> The course instructors are
                          seasoned professionals who have hands-on experience in
                          building scalable systems. They emphasize the
                          practical importance of Data Structures and Algorithms
                          (DSA) and System Design, going beyond
                          interview-focused material.
                        </li>

                        <li>
                          <b>Responsive Support:</b> Quick doubt resolution is
                          made possible by a team of over 100 Teaching
                          Assistants, ensuring that you receive timely help and
                          guidance throughout your learning journey.
                        </li>

                        <li>
                          <b>Peer Collaboration:</b> You'll join an inspiring
                          peer group and gain access to ScalerChat, an internal
                          communication platform. Here, you can collaborate on
                          projects, share authentic interview experiences, and
                          even facilitate job referrals.
                        </li>

                        <li>
                          <b>Flexibility:</b> The course offers a flexible
                          curriculum, enabling you to continue learning even if
                          you have a busy work schedule. Recorded lectures are
                          available for viewing later, and you can switch
                          between batches at no additional cost.
                        </li>

                        <li>
                          <b>Career Support:</b> Logicmojo provides robust
                          career support, including access to job opportunities
                          through their network of 600+ employer partners. They
                          also offer mock interview services and career planning
                          assistance to help you achieve your professional
                          goals.
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div className="card">
                  <div className="card-header" id="heading02">
                    <h3 className="mb-0">
                      <button
                        type="button"
                        className="btn btn-link collapsed"
                        data-toggle="collapse"
                        data-target="#collapse02"
                        aria-expanded="false"
                      >
                        <i className="fa fa-angle-down"></i> Who should take
                        this Full Stack Developer Course ?
                      </button>
                    </h3>
                  </div>

                  <div
                    id="collapse02"
                    className="collapse"
                    aria-labelledby="heading02"
                    data-parent="#accordionExample2"
                  >
                    <div className="card-body">
                      <p>
                        <b>
                          Logicmojo's Full Stack Developer Course is ideal
                          for:
                        </b>
                      </p>

                      <ul>
                        <li>
                          Aspiring web developers looking to start a career in
                          web development.
                        </li>
                        <li>
                          Software engineers aiming to expand their skill set
                          and transition into full stack development.
                        </li>
                        <li>
                          Professionals seeking to enhance their web development
                          expertise.
                        </li>
                        <li>
                          Career changers interested in entering the dynamic
                          field of web development.
                        </li>
                      </ul>

                      <p>
                        Whether you are a beginner, an experienced coder, or
                        someone looking to switch careers, this course provides
                        the knowledge and practical skills to thrive in the
                        world of full stack web development.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="card">
                  <div className="card-header" id="heading04">
                    <h3 className="mb-0">
                      <button
                        type="button"
                        className="btn btn-link collapsed"
                        data-toggle="collapse"
                        data-target="#collapse04"
                        aria-expanded="false"
                      >
                        <i className="fa fa-angle-down"></i> How much time do I
                        have to commit to this certification course?
                      </button>
                    </h3>
                  </div>

                  <div
                    id="collapse04"
                    className="collapse"
                    aria-labelledby="heading04"
                    data-parent="#accordionExample2"
                  >
                    <div className="card-body">
                      <p>
                        To successfully complete the Full Stack Developer
                        Certification Course, you should be prepared to dedicate
                        approximately 6 hours per week to your learning journey.
                      </p>

                      <p>
                        This program offers flexibility in terms of class
                        schedules. You can choose from classes conducted on both
                        weekends and weekdays, depending on your batch's
                        availability. This flexibility ensures that you can
                        balance your learning with your existing commitments and
                        responsibilities.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="card">
                  <div className="card-header" id="heading050">
                    <h3 className="mb-0">
                      <button
                        type="button"
                        className="btn btn-link collapsed"
                        data-toggle="collapse"
                        data-target="#collapse050"
                        aria-expanded="false"
                      >
                        <i className="fa fa-angle-down"></i> What happens if I
                        miss a lecture in this online course?
                      </button>
                    </h3>
                  </div>

                  <div
                    id="collapse050"
                    className="collapse"
                    aria-labelledby="heading050"
                    data-parent="#accordionExample2"
                  >
                    <div className="card-body">
                      <p>
                        If you happen to miss a lecture in our online Full Stack
                        Developer course, there's no need to worry.
                      </p>

                      <p>
                        We understand that life can be unpredictable, and
                        scheduling conflicts may arise. That's why all our
                        lectures are meticulously recorded. Once a lecture
                        concludes, you will gain access to the recorded session.
                        This means you can catch up on any missed content at
                        your convenience. We've designed our course to
                        accommodate your flexibility and ensure you don't miss
                        out on valuable learning opportunities.
                      </p>
                    </div>
                  </div>
                </div>

                <button
                  onClick={() => setTg(!toggle)}
                  className="btn btn-primary mb-3 viewmorebtn"
                >
                  {toggle ? "View Less" : "View More"}
                </button>

                {toggle && (
                  <div className="morefaq">
                    <div className="card">
                      <div className="card-header" id="heading07">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse07"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> What are the
                            roles and responsibilities of a Full Stack
                            Developer?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse07"
                        className="collapse"
                        aria-labelledby="heading07"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Full Stack Developers play a pivotal role in web
                            development, possessing expertise in both front-end
                            and back-end coding. Their responsibilities
                            encompass:
                          </p>

                          <ul>
                            <li>
                              Designing user interactions on websites, ensuring
                              seamless and engaging experiences for users.
                            </li>
                            <li>
                              Developing servers and databases to underpin the
                              functionality of websites, ensuring data is stored
                              and retrieved efficiently.
                            </li>
                            <li>
                              Coding for mobile platforms, ensuring web
                              applications are responsive and accessible on
                              various devices.
                            </li>
                            <li>
                              Designing and developing APIs (Application
                              Programming Interfaces), facilitating data
                              exchange and integration with external services.
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading08">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse08"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> What is the
                            duration of this program?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse08"
                        className="collapse"
                        aria-labelledby="heading08"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            The Full Stack Web Developer Course is designed as a
                            comprehensive 10-month program. It encompasses:
                          </p>

                          <ul>
                            <li>
                              Live, instructor-led classes to provide real-time
                              guidance and learning.
                            </li>
                            <li>
                              Structured assignments and projects to reinforce
                              your skills and knowledge throughout the course.
                            </li>
                          </ul>

                          <p>
                            This 10-month duration ensures that students have
                            ample time to grasp the intricacies of full stack
                            web development and build a strong foundation for
                            their future careers.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading09">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse09"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> What is a Flexi
                            Subscription in Full stack web development Course ?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse09"
                        className="collapse"
                        aria-labelledby="heading09"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            A Flexi Subscription in the Full Stack Web
                            Developer Course offers:
                          </p>

                          <ul>
                            <li>
                              Access to live classroom training in Full Stack Development.
                            </li>
                            <li>
                              2 years of access to ongoing batch information.
                            </li>
                            <li>
                              The ability to attend live sessions from any
                              batch, providing flexibility in learning.
                            </li>
                            <li>
                              An opportunity for participants to learn at their
                              own pace, accommodating various schedules,
                              including those who work shifts or weekends.
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading10">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse10"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> What study
                            material will be provided to me for the Course?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse10"
                        className="collapse"
                        aria-labelledby="heading10"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <ul>
                            <li>
                              Online live lectures on weekdays and online or
                              classroom sessions on weekends for core learning.
                            </li>
                            <li>
                              Recordings of the online lectures for convenient
                              review and reference.
                            </li>
                            <li>
                              Access to comprehensive student notes, exercises,
                              and additional study materials.
                            </li>
                            <li>
                              Assessments to track your progress and
                              understanding.
                            </li>
                            <li>
                              Full integration with an online learning portal
                              for easy access and organization of resources.
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading11">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse11"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> Can I do full
                            stack developer course online?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse11"
                        className="collapse"
                        aria-labelledby="heading11"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Yes, you can pursue the Full Stack Developer
                            online course by Logicmojo. This comprehensive
                            online course is designed to help individuals
                            achieve their dream of becoming a Full Stack
                            Developer. It covers all the essential knowledge and
                            skills required to gain expertise in the field of
                            Full Stack Development.
                          </p>

                          <p>
                            With the flexibility of online learning, you can
                            access the course content, participate in live
                            sessions, and complete assignments and projects from
                            the comfort of your own location, making it
                            convenient for learners from various backgrounds and
                            locations.
                          </p>

                          <p>
                            Embark on your journey to become a Full Stack
                            Developer with the Logicmojo online course.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading12">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse12"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> What knowledge
                            can be gained from this top-notch Logicmojo's Full
                            Stack Development Course?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse12"
                        className="collapse"
                        aria-labelledby="heading12"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            The Logicmojo's Full Stack Developer Course is
                            designed to provide participants with comprehensive
                            knowledge and skills in the field of Full Stack
                            Development. By enrolling in this top-notch course,
                            you can expect to gain expertise in the following
                            areas:
                          </p>

                          <ul>
                            <li>Front-end Development:</li>
                            <ul>
                              <li>HTML</li>
                              <li>CSS</li>
                              <li>JavaScript</li>
                              <li>React</li>
                              <li>Bootstrap</li>
                            </ul>
                            <li>Back-end Development:</li>
                            <ul>
                              <li>Node.js</li>
                              <li>Express.js</li>
                              <li>MongoDB</li>
                            </ul>
                            <li>DevOps Technologies:</li>
                            <ul>
                              <li>Git</li>
                              <li>Docker</li>
                            </ul>
                            <li>
                              Software Development Principles and Practices:
                            </li>
                            <ul>
                              <li>Agile development</li>
                              <li>Object-oriented programming</li>
                              <li>Data structures and algorithms</li>
                            </ul>
                            <li>Version Control Systems:</li>
                            <ul>
                              <li>Git</li>
                            </ul>
                            <li>Testing and Debugging:</li>
                            <ul>
                              <li>Unit testing</li>
                              <li>Integration testing</li>
                              <li>End-to-end testing</li>
                            </ul>
                            <li>Cloud Computing:</li>
                            <ul>
                              <li>AWS</li>
                              <li>Azure</li>
                              <li>GCP (Google Cloud Platform)</li>
                            </ul>
                          </ul>

                          <p>
                            This course equips you with the necessary skills to
                            excel in Full Stack Development, making you a
                            proficient developer capable of handling both
                            front-end and back-end tasks, along with knowledge
                            of essential tools and best practices in the
                            industry.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading14">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse14"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> Can I learn
                            full stack Development in 3 months?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse14"
                        className="collapse"
                        aria-labelledby="heading14"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Becoming a proficient full-stack developer typically
                            requires a solid foundation in both front-end and
                            back-end technologies, as well as practical
                            experience in building applications. While it's
                            possible to learn a lot in 90 days, achieving
                            mastery in such a short time frame might be
                            unrealistic for most people. Full stack development
                            is a multifaceted field that encompasses various
                            programming languages, frameworks, and tools.
                          </p>

                          <p>
                            Logicmojo's Full Stack Developer Course
                            provides comprehensive training over a longer
                            duration, allowing learners to build a strong skill
                            set and work on real-world projects. Learning at
                            your own pace, with hands-on experience and
                            mentorship, ensures a deeper understanding of the
                            concepts. Rushing through a course in 3 months may
                            not provide the same level of expertise and
                            practical knowledge that a more extended program
                            offers. Remember that proficiency often comes with
                            time, practice, and dedication, and it's essential
                            to focus on quality learning rather than just speed.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading15">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse15"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> What is the
                            salary of a full stack developer in India?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse15"
                        className="collapse"
                        aria-labelledby="heading15"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Full Stack Developers in India can earn salaries
                            that vary depending on factors such as experience,
                            location, and the specific employer. On average, the
                            annual salary for a Full Stack Developer in India is
                            around ₹8.4 Lakhs, but this figure can range from
                            ₹1.8 Lakhs to ₹16.0 Lakhs or even more.
                          </p>

                          <p>
                            These salary estimates are derived from data
                            collected from 28.5k Full Stack Developers in the
                            country. It's important to note that a Full Stack
                            Developer's earning potential can increase
                            significantly with experience and expertise.
                            Developers with advanced skills in front-end and
                            back-end technologies, as well as proficiency in
                            popular frameworks and tools, tend to command higher
                            salaries.
                          </p>

                          <p>
                            Location also plays a crucial role, with
                            metropolitan cities like Bangalore, Hyderabad, and
                            Mumbai offering higher compensation due to the cost
                            of living and demand for tech talent. Ultimately, a
                            Full Stack Developer's salary reflects their skills,
                            experience, and the market dynamics in the region
                            they work in.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading16">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse16"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> Can a fresher
                            learn full-stack development ?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse16"
                        className="collapse"
                        aria-labelledby="heading16"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Absolutely, yes. Learning full-stack development as
                            a fresher is not only possible but also a wise
                            career move in today's tech-centric world.
                            Full-stack developers are among the most
                            sought-after and well-compensated professionals in
                            the IT industry.
                          </p>

                          <p>
                            Many full-stack development courses are designed to
                            cater to individuals at various skill levels,
                            including beginners and fresh graduates. These
                            courses typically provide a structured curriculum
                            that covers both front-end and back-end
                            technologies, making it accessible for newcomers to
                            acquire the necessary skills.
                          </p>

                          <p>
                            As a fresher, embarking on a full-stack development
                            journey can open doors to exciting career
                            opportunities. With dedication, practice, and a
                            willingness to learn, you can develop proficiency in
                            a relatively short time frame. By completing a
                            comprehensive full-stack development course, you can
                            gain practical knowledge and build a strong
                            portfolio, making you a valuable asset to potential
                            employers.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading17">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse17"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> How do I start
                            full-stack development?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse17"
                        className="collapse"
                        aria-labelledby="heading17"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Embarking on a career in full-stack development
                            requires a systematic approach and dedication to
                            learning. Here's a step-by-step guide to help you
                            get started:
                          </p>

                          <ol>
                            <li>
                              Complete the basics of computer science: Start
                              with a solid foundation in computer science
                              concepts, including algorithms, data structures,
                              and problem-solving skills. These form the bedrock
                              of your programming journey.
                            </li>

                            <li>
                              Learn basic programming languages: Begin with
                              essential programming languages like HTML, CSS,
                              and JavaScript. These are fundamental to web
                              development and will serve as your entry point
                              into the field.
                            </li>

                            <li>
                              Gain knowledge of development frameworks and
                              tools: Familiarize yourself with popular web
                              development frameworks and tools such as React,
                              Angular, Vue.js, Node.js, and Express.js. These
                              technologies are crucial for building dynamic web
                              applications.
                            </li>

                            <li>
                              Learn about databases and caching: Understand
                              database management systems (DBMS) like MySQL,
                              MongoDB, or PostgreSQL, and explore caching
                              mechanisms to optimize data retrieval and storage.
                            </li>

                            <li>
                              Practice coding: The key to mastery is consistent
                              practice. Work on coding exercises, personal
                              projects, and challenges to reinforce your skills
                              and deepen your understanding.
                            </li>

                            <li>
                              Gain relevant experience: Apply your knowledge by
                              working on real-world projects. Internships,
                              freelancing, or contributing to open-source
                              projects can provide valuable experience and build
                              your portfolio.
                            </li>
                          </ol>

                          <p>
                            As you progress, regularly update your resume to
                            showcase your growing skills and projects.
                            Full-stack development is a dynamic field, so
                            staying updated with emerging technologies and
                            trends is crucial for long-term success.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading18">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse18"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> Can I self
                            study full stack developer?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse18"
                        className="collapse"
                        aria-labelledby="heading18"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Absolutely, self-study is a viable path to becoming
                            a proficient full-stack developer. Many successful
                            developers are self-taught and lack formal education
                            in the field. However, the journey requires
                            dedication, discipline, and a structured approach.
                            Here's a breakdown of the process:
                          </p>

                          <ul>
                            <li>
                              <b>Strong Foundation:</b> Whether you opt for
                              self-study or formal education, a strong
                              foundation in programming languages, databases,
                              and web development frameworks is indispensable.
                              Start with languages like HTML, CSS, and
                              JavaScript.
                            </li>

                            <li>
                              <b>Comprehensive Learning:</b> Utilize online
                              resources, tutorials, documentation, and coding
                              exercises to gain in-depth knowledge. Explore
                              frameworks such as React, Node.js, and Express.js,
                              as well as databases like MySQL or MongoDB.
                            </li>

                            <li>
                              <b>Hands-on Practice:</b> Practical application is
                              key. Create personal projects, contribute to
                              open-source initiatives, or work on freelance
                              assignments to apply your skills and build a
                              portfolio.
                            </li>

                            <li>
                              <b>Continuous Learning:</b> Full-stack development
                              is a dynamic field. Stay updated with evolving
                              technologies and best practices through blogs,
                              forums, and online communities.
                            </li>

                            <li>
                              <b>Problem-Solving:</b> Cultivate problem-solving
                              abilities, as they are vital for addressing
                              real-world challenges in development.
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading19">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse19"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> Which full
                            stack is in demand?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse19"
                        className="collapse"
                        aria-labelledby="heading19"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Full stack developers, with the ability to work
                            seamlessly on both front-end and back-end
                            technologies, are highly sought-after in today's job
                            market. While the demand for full stack developers
                            is generally robust, certain technology stacks stand
                            out as particularly in-demand.
                          </p>

                          <p>
                            <b>React and Node.js:</b> Among the plethora of
                            frameworks and libraries available, developers
                            proficient in React and Node.js are currently in
                            high demand. React, a JavaScript library for
                            building user interfaces, is widely used in
                            front-end development due to its flexibility and
                            efficiency. Node.js, a runtime environment for
                            executing JavaScript code on the server-side,
                            complements React effectively for full stack
                            development. The combination of React and Node.js
                            enables developers to create responsive, real-time
                            web applications, making them valuable assets to
                            employers.
                          </p>

                          <p>
                            As technology continues to evolve, staying updated
                            and expanding your skill set in these in-demand full
                            stack technologies can open doors to exciting career
                            opportunities.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading20">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse20"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> How long does
                            it take to become a full stack developer?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse20"
                        className="collapse"
                        aria-labelledby="heading20"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            The journey to becoming a full stack developer is
                            unique for each individual. It can span from several
                            months to a few years, contingent upon various
                            factors such as the chosen learning path,
                            educational background, and the intensity of the
                            learning process.
                          </p>

                          <p>
                            Some aspiring full stack developers may choose to
                            embark on a self-paced learning journey, which can
                            take longer due to the flexibility of their
                            schedule. Others may opt for a formal degree
                            program, which typically spans several years, or an
                            immersive boot camp, which can condense the learning
                            process into a matter of months.
                          </p>

                          <p>
                            Regardless of the chosen path, consistent practice,
                            engagement in diverse projects, and proficiency in
                            different programming languages and frameworks are
                            essential. Mastery in full stack development is an
                            ongoing process that demands dedication and
                            continuous learning to stay updated with evolving
                            technologies.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading21">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse21"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> What is the
                            process of resolving doubts?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse21"
                        className="collapse"
                        aria-labelledby="heading21"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Resolving doubts is a crucial aspect of the learning
                            process at Logicmojo's Full Stack Developer
                            Course, and it follows a structured approach to
                            ensure learners receive the assistance they need.
                          </p>

                          <p>
                            When a student encounters a doubt or question, they
                            initiate a 'Doubt Session.' This session is first
                            shared with their peer group, encouraging
                            collaborative learning and community building.
                            Simultaneously, the instructor is also notified
                            about the 'Doubt Session' to ensure timely
                            attention.
                          </p>

                          <p>
                            The doubt can be addressed through two primary
                            channels. Firstly, the peer group may collectively
                            work together to provide explanations and insights,
                            fostering a culture of mutual support. Secondly, the
                            instructor can directly engage with the student to
                            clarify doubts, either through written communication
                            or via video calls.
                          </p>

                          <p>
                            During video calls, the instructor has the option to
                            share their screen, enabling a more immersive
                            learning experience. These video calls are conducted
                            on a one-on-one basis, ensuring personalized
                            attention and focused problem-solving.
                          </p>

                          <p>
                            This robust doubt resolution process ensures that
                            learners have multiple avenues to seek help,
                            creating an environment where questions are
                            encouraged and answered effectively.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading22">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse22"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> What is the
                            process of getting into the placement pool ?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse22"
                        className="collapse"
                        aria-labelledby="heading22"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Joining the placement pool at Logicmojo's Full Stack
                            Developer Course involves a structured process
                            designed to ensure that learners are well-prepared
                            and equipped for successful job placements.
                          </p>

                          <p>
                            First and foremost, learners must complete the
                            course satisfactorily. This includes diligently
                            submitting all projects and assignments,
                            demonstrating their proficiency and commitment to
                            the program. Successful project completion showcases
                            a learner's practical skills and understanding of
                            the course material.
                          </p>

                          <p>
                            Furthermore, learners must pass the Placement
                            Readiness Test (PRT). This test is a pivotal step in
                            assessing a learner's preparedness for job
                            placements. It evaluates their knowledge, skills,
                            and aptitude, ensuring they meet the necessary
                            standards for employability.
                          </p>

                          <p>
                            Once a learner has met these criteria by completing
                            the course and passing the PRT, they gain access to
                            the Logicmojo job portal. This portal provides a
                            gateway to numerous job opportunities, connecting
                            learners with potential employers and career
                            prospects.
                          </p>

                          <p>
                            In addition to job listings, learners in the
                            placement pool can participate in career mentoring
                            sessions. These sessions offer valuable insights,
                            guidance, and support to help learners navigate the
                            job market successfully.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading23">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse23"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> What are the
                            different modes of Courses that Logicmojo provides
                            for Full Stack Developer Program?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse23"
                        className="collapse"
                        aria-labelledby="heading23"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Logicmojo recognizes that every learner is unique
                            and has specific preferences and requirements when
                            it comes to their Full Stack Developer training.
                            To cater to a diverse audience, we offer a range of
                            course modes:
                          </p>

                          <ul>
                            <li>
                              <b>Instructor-Led Online Training:</b> In this
                              mode, learners can participate in live,
                              instructor-led classes conducted online. These
                              classes provide real-time interaction with
                              experienced trainers who bring over 12 years of
                              industry expertise to the table. The online format
                              ensures flexibility, allowing learners to join
                              from anywhere, making it an ideal choice for those
                              seeking structured, interactive learning.
                            </li>

                            <li>
                              <b>Self-Paced Training Program:</b> For learners
                              who prefer a more independent and flexible
                              approach, our self-paced training program is an
                              excellent option. It allows learners to access
                              course materials and resources at their
                              convenience. This mode is suitable for individuals
                              who have busy schedules or prefer to learn at
                              their own pace, providing the freedom to progress
                              through the material as they see fit.
                            </li>

                            <li>
                              <b>Corporate Training:</b> Logicmojo also extends
                              its offerings to organizations looking to upskill
                              their workforce in Full Stack Development. Our
                              corporate training programs are tailored to meet
                              the specific needs and goals of businesses. By
                              leveraging the expertise of our trainers, who have
                              worked as consultants in the field, organizations
                              can ensure their teams receive top-notch training
                              to excel in Full Stack Development.
                            </li>
                          </ul>

                          <p>
                            We encourage all prospective learners to explore our
                            sample videos to gauge the quality of our trainers
                            and the effectiveness of our courses. Regardless of
                            the mode chosen, Logicmojo is committed to providing
                            comprehensive and industry-relevant Full Stack
                            Development training to help individuals and
                            organizations achieve their goals.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading24">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse24"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> What are the
                            benefits of learning full stack development?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse24"
                        className="collapse"
                        aria-labelledby="heading24"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Learning full stack development offers a multitude
                            of advantages, making it a highly valuable skill set
                            in today's tech-driven world. Here are some
                            compelling benefits:
                          </p>

                          <ul>
                            <li>
                              <b>Versatility:</b> Full stack developers possess
                              expertise in both front-end and back-end
                              technologies. This versatility allows them to work
                              on various aspects of web development, making them
                              indispensable assets for companies looking to
                              create robust, end-to-end web applications.
                            </li>

                            <li>
                              <b>Cost-Efficiency:</b> Hiring a single full stack
                              developer who can handle multiple tasks is often
                              more cost-effective for businesses than hiring
                              separate front-end and back-end developers. This
                              cost savings is particularly appealing for
                              startups and small businesses.
                            </li>

                            <li>
                              <b>Rapid Prototyping:</b> Full stack developers
                              can quickly prototype and test ideas, enabling
                              faster development cycles. This agility is
                              essential for staying competitive in the
                              ever-evolving tech industry.
                            </li>

                            <li>
                              <b>Entrepreneurial Opportunities:</b> Full stack
                              developers have the skills to bring their own
                              web-based ideas to life. This empowers them to
                              become entrepreneurs and turn their innovative
                              concepts into successful online ventures.
                            </li>

                            <li>
                              <b>High Demand:</b> The demand for full stack
                              developers is consistently high across various
                              industries, resulting in lucrative career
                              opportunities and job security.
                            </li>

                            <li>
                              <b>Problem Solving:</b> Full stack developers
                              excel in problem-solving. They can troubleshoot
                              issues across the entire development stack, from
                              user interface glitches to server-side bugs.
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading25">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse25"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> What are the
                            prerequisites for enrolling in this full stack
                            developer course?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse25"
                        className="collapse"
                        aria-labelledby="heading25"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            One of the standout features of the Logicmojo Full
                            Stack Developer Course is its accessibility.
                            There are no prerequisites required to enroll in
                            this comprehensive program. Whether you are a
                            complete novice in web development or an experienced
                            professional looking to bolster your skill set, this
                            course is designed to accommodate learners of all
                            levels.
                          </p>

                          <p>
                            This inclusivity is a testament to Logicmojo's
                            commitment to providing a learning environment that
                            caters to a diverse range of individuals. Here's why
                            the lack of prerequisites is a significant
                            advantage:
                          </p>

                          <ul>
                            <li>
                              <b>Open to Beginners:</b> If you're new to web
                              development, this course is an excellent starting
                              point. You won't encounter any barriers to entry,
                              ensuring you can embark on your learning journey
                              without prior technical knowledge.
                            </li>

                            <li>
                              <b>Accessible Skill Enhancement:</b> For
                              experienced professionals, this course offers an
                              opportunity to upskill and stay current with the
                              latest web development trends and technologies.
                              It's a chance to diversify your expertise without
                              hindrance.
                            </li>

                            <li>
                              <b>Inclusive Learning:</b> Logicmojo embraces
                              diversity in its student body, fostering an
                              inclusive learning community where individuals
                              from various backgrounds can thrive.
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading26">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse26"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> What kind of
                            roles do employers hire for?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse26"
                        className="collapse"
                        aria-labelledby="heading26"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Employers in today's competitive job market seek
                            candidates with diverse skills and expertise, and
                            full-stack developers are in high demand across
                            various industries. When exploring job opportunities
                            as a full-stack developer, you'll encounter a range
                            of roles that can align with your qualifications and
                            strengths. Here are some of the key roles where
                            employers frequently hire full-stack developers:
                          </p>

                          <ul>
                            <li>
                              <b>Full-Stack Developer:</b> This role encompasses
                              both front-end and back-end development, requiring
                              proficiency in a wide array of technologies to
                              build and maintain complete web applications.
                            </li>

                            <li>
                              <b>Backend Developer:</b> Backend developers focus
                              on server-side programming, database management,
                              and server optimization. They play a critical role
                              in ensuring the functionality and performance of
                              web applications.
                            </li>

                            <li>
                              <b>Front-End Developer:</b> Front-end developers
                              specialize in creating user interfaces and
                              experiences. They work with technologies like
                              HTML, CSS, and JavaScript to enhance user
                              interactions.
                            </li>

                            <li>
                              <b>UI/UX Designer:</b> Full-stack developers with
                              design skills can excel in UI/UX roles, where they
                              craft visually appealing and user-friendly
                              interfaces for web applications.
                            </li>

                            <li>
                              <b>Software Engineer:</b> Some full-stack
                              developers transition into broader software
                              engineering roles, contributing to the development
                              of software solutions beyond web applications.
                            </li>

                            <li>
                              <b>DevOps Engineer:</b> DevOps focuses on the
                              seamless integration of development and IT
                              operations. Full-stack developers with DevOps
                              skills are valuable for automating and
                              streamlining deployment processes.
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading27">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse27"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> Does Logicmojo
                            offer job assistance after completing Full stack Web
                            development course?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse27"
                        className="collapse"
                        aria-labelledby="heading27"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Yes, Logicmojo is committed to supporting learners
                            in their career journey even after they complete the
                            Full Stack Developer Course. Our comprehensive
                            job assistance program is designed to connect you
                            with exciting opportunities in the field of full
                            stack development. Here's how we assist our
                            graduates:
                          </p>

                          <ul>
                            <li>
                              <b>Placement Assistance:</b> Logicmojo
                              collaborates with numerous leading multinational
                              corporations (MNCs) globally. This network
                              includes renowned companies such as TCS, Sony,
                              Ericsson, Cisco, Cognizant, Mu Sigma, Standard
                              Chartered, and many others. Our learners benefit
                              from a wide array of job opportunities in these
                              esteemed organizations.
                            </li>

                            <li>
                              <b>Resume Building:</b> Crafting an impressive
                              resume is crucial for a successful job search. Our
                              team provides guidance and support to help you
                              create a compelling resume that highlights your
                              skills and achievements effectively.
                            </li>

                            <li>
                              <b>Interview Preparation:</b> Job interviews can
                              be challenging, but we're here to help you
                              prepare. Logicmojo offers interview preparation
                              assistance, including mock interviews and valuable
                              tips, to boost your confidence and increase your
                              chances of landing your dream job.
                            </li>

                            <li>
                              <b>Industry Connect:</b> We maintain strong
                              industry connections, ensuring that you gain
                              access to the latest trends and job openings in
                              the full stack development field. Our vast network
                              provides valuable insights and opportunities for
                              career growth.
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading28">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse28"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> Is full-stack
                            web development difficult to learn?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse28"
                        className="collapse"
                        aria-labelledby="heading28"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Full-stack web development is a multifaceted field
                            that encompasses both front-end and back-end
                            technologies, making it a comprehensive skill set to
                            acquire. While it may seem daunting at first, the
                            difficulty of learning full-stack development
                            largely depends on your prior experience and
                            dedication. Here are some factors to consider:
                          </p>

                          <ul>
                            <li>
                              <b>Background:</b> If you already have some
                              programming experience, transitioning to
                              full-stack development can be more manageable.
                              However, even beginners can learn if they are
                              committed to the process.
                            </li>

                            <li>
                              <b>Learning Resources:</b> Access to quality
                              learning resources, such as structured courses,
                              tutorials, and mentorship, can significantly ease
                              the learning curve.
                            </li>

                            <li>
                              <b>Practice:</b> Full-stack development requires
                              practical experience. Regular coding and
                              project-building are essential to reinforce your
                              skills.
                            </li>

                            <li>
                              <b>Problem-Solving:</b> As a full-stack developer,
                              you'll encounter various challenges.
                              Problem-solving abilities and a logical mindset
                              are valuable assets.
                            </li>

                            <li>
                              <b>Continuous Learning:</b> Technology evolves
                              rapidly. Full-stack developers must stay updated
                              with the latest tools and frameworks, making
                              lifelong learning a crucial aspect of the
                              profession.
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading29">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse29"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> What level of
                            coding proficiency is necessary to be successful as
                            a full stack developer?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse29"
                        className="collapse"
                        aria-labelledby="heading29"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Success as a full-stack web developer requires a
                            high level of coding proficiency across various
                            domains. Full-stack developers play a critical role
                            in designing, building, and maintaining web
                            applications, which demands a versatile skill set.
                            Here are some key aspects of coding proficiency
                            necessary for success:
                          </p>

                          <ul>
                            <li>
                              <b>Front-end Development:</b> Full-stack
                              developers need to excel in HTML, CSS, and
                              JavaScript, as these languages are fundamental for
                              creating user interfaces and enhancing user
                              experiences.
                            </li>

                            <li>
                              <b>Back-end Development:</b> Proficiency in
                              server-side languages such as Python, Ruby, or
                              Node.js is essential. These languages enable
                              developers to manage databases, handle server
                              requests, and implement application logic.
                            </li>

                            <li>
                              <b>Database Management:</b> A full-stack developer
                              should have knowledge of database systems like
                              MySQL, MongoDB, or PostgreSQL. They need to design
                              and manage databases efficiently to store and
                              retrieve data.
                            </li>

                            <li>
                              <b>Version Control:</b> Using tools like Git for
                              version control is crucial for collaboration and
                              code management within development teams.
                            </li>

                            <li>
                              <b>Problem Solving:</b> Full-stack developers must
                              possess strong problem-solving skills. They
                              encounter complex challenges and must find
                              efficient solutions.
                            </li>

                            <li>
                              <b>Frameworks and Libraries:</b> Familiarity with
                              various frameworks and libraries like React,
                              Angular, Express.js, or Django can enhance
                              productivity and help developers create robust
                              applications.
                            </li>

                            <li>
                              <b>Continuous Learning:</b> The tech industry
                              evolves rapidly. Full-stack developers need to
                              stay updated with emerging technologies and best
                              practices.
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading30">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse30"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> How many
                            mentors are allotted per batch?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse30"
                        className="collapse"
                        aria-labelledby="heading30"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Logicmojo's commitment to personalized learning
                            includes offering mentorship to learners. The
                            mentorship program is carefully designed to provide
                            valuable guidance and support throughout your Full
                            Stack Web Development journey.
                          </p>
                          <ul>
                            <li>
                              <b>Mentor Selection:</b> At the beginning of the
                              course, learners are presented with a pool of
                              mentors. The selection process allows you to
                              choose one mentor from this pool. This choice is
                              crucial as it allows you to connect with a mentor
                              whose background aligns with your goals and
                              interests.
                            </li>

                            <li>
                              <b>Personalized Guidance:</b> Your chosen mentor
                              becomes your point of contact for personalized
                              guidance. They offer insights, answer your
                              queries, and provide assistance to help you excel
                              in the course.
                            </li>

                            <li>
                              <b>Background Alignment:</b> Logicmojo strives to
                              match mentors with learners who share similar
                              backgrounds or aspirations. This relatability
                              enhances the effectiveness of the mentorship
                              relationship.
                            </li>

                            <li>
                              <b>Continuous Support:</b> Throughout the course,
                              your mentor remains accessible to address your
                              concerns and provide clarity on course materials.
                              They can also offer career advice and insights
                              into the tech industry.
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading32">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse32"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> What are the
                            job prospects for full stack developers?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse32"
                        className="collapse"
                        aria-labelledby="heading32"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            The career prospects for full stack developers are
                            exceptionally promising in today's technology-driven
                            job market. The demand for these versatile
                            professionals has been on a remarkable upswing, as
                            evidenced by various reports and trends:
                          </p>

                          <ul>
                            <li>
                              <b>Continuous Growth:</b> LinkedIn's report
                              reveals a staggering 35% annual increase in demand
                              for full-stack developers since 2015. This growth
                              trajectory showcases the critical role they play
                              in the tech industry.
                            </li>

                            <li>
                              <b>Robust Job Market:</b> According to data from
                              the US Bureau of Labor Statistics, the number of
                              job opportunities for full stack developers is set
                              to surge from 135,000 to over 853,000 by 2024.
                              This substantial expansion signifies the
                              indispensable nature of their skills.
                            </li>

                            <li>
                              <b>Industry Agnostic:</b> Full stack developers
                              are in demand across various sectors, including
                              technology, finance, healthcare, and education.
                              Their adaptability and proficiency make them
                              valuable assets in virtually any industry.
                            </li>

                            <li>
                              <b>Competitive Salaries:</b> Full stack developers
                              typically enjoy competitive salaries in the tech
                              field, reflecting their sought-after expertise.
                              This translates to excellent earning potential for
                              those pursuing this career path.
                            </li>

                            <li>
                              <b>Entrepreneurial Opportunities:</b> With their
                              comprehensive knowledge of web development, full
                              stack developers are well-equipped to launch
                              startups or contribute to innovation within
                              established companies.
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading33">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse33"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i>What are some
                            steps I can take to learn Full Stack Development and
                            become proficient in it?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse33"
                        className="collapse"
                        aria-labelledby="heading33"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Becoming a proficient full stack developer is an
                            achievable goal with dedication and a structured
                            approach. Here are steps to guide you on your
                            journey to mastering full stack development:
                          </p>

                          <ol>
                            <li>
                              <b>Build a Strong Foundation:</b> Start by
                              learning the basics of computer science, including
                              algorithms and data structures. A solid foundation
                              is crucial for advanced development.
                            </li>

                            <li>
                              <b>Master Core Technologies:</b> Gain proficiency
                              in fundamental programming languages like HTML,
                              CSS, and JavaScript. These are essential for
                              front-end development.
                            </li>

                            <li>
                              <b>Explore Frameworks and Tools:</b> Dive into
                              development frameworks and tools, such as React,
                              Angular, or Vue.js for front-end, and Node.js,
                              Ruby on Rails, or Django for back-end.
                            </li>

                            <li>
                              <b>Understand Databases:</b> Learn how to work
                              with databases, both SQL and NoSQL, to manage data
                              effectively.
                            </li>

                            <li>
                              <b>Practice Coding:</b> Practice regularly by
                              working on real projects. Building web
                              applications and solving coding challenges will
                              hone your skills.
                            </li>

                            <li>
                              <b>Gain Relevant Experience:</b> Look for
                              internships, freelance projects, or entry-level
                              positions to apply your knowledge in real-world
                              scenarios.
                            </li>

                            <li>
                              <b>Stay Updated:</b> Keep up with industry trends
                              and emerging technologies. Attend webinars,
                              workshops, and read relevant blogs to stay
                              informed.
                            </li>

                            <li>
                              <b>Collaborate and Network:</b> Collaborate with
                              other developers, join coding communities, and
                              network with professionals in the field. Sharing
                              knowledge and experiences can accelerate your
                              growth.
                            </li>

                            <li>
                              <b>Build a Portfolio:</b> Create a portfolio
                              showcasing your projects. A strong portfolio is
                              your best asset when seeking job opportunities.
                            </li>

                            <li>
                              <b>Continuous Learning:</b> Full stack development
                              is ever-evolving. Commit to continuous learning
                              and be open to exploring new technologies as they
                              emerge.
                            </li>
                          </ol>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading34">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse34"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> What are the
                            salary expectations for full stack developers?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse34"
                        className="collapse"
                        aria-labelledby="heading34"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Full stack developers are highly sought-after
                            professionals in the tech industry, and their
                            salaries can vary based on factors like experience,
                            location, and the specific skills they possess. In
                            India, the salary range for full stack developers is
                            quite diverse.
                          </p>

                          <p>
                            On the lower end of the spectrum, junior full stack
                            developers with limited experience might earn around
                            ₹1.8 Lakhs per annum. However, as they gain
                            expertise and experience, their earning potential
                            increases significantly. Mid-level full stack
                            developers can command salaries ranging from ₹5
                            Lakhs to ₹10 Lakhs annually, while senior
                            professionals with several years of experience can
                            earn as much as ₹16 Lakhs or more.
                          </p>

                          <p>
                            The average annual salary for full stack developers
                            in India is approximately ₹8.5 Lakhs. These salary
                            estimates are based on data from a substantial
                            number of full stack developers, reflecting the
                            industry's demand for their versatile skill set.
                          </p>

                          <p>
                            It's important to note that salaries can also vary
                            based on the location within India, with
                            metropolitan areas typically offering higher
                            compensation to tech professionals. Additionally,
                            proficiency in specific in-demand technologies, such
                            as React, Node.js, or cloud computing, can further
                            boost a full stack developer's earning potential.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading35">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse35"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> What are some
                            of the challenges of being a full stack developer?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse35"
                        className="collapse"
                        aria-labelledby="heading35"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Becoming a full stack developer is a rewarding
                            journey, but it comes with its own set of
                            challenges. Here are some of the common challenges
                            faced by full stack developers:
                          </p>

                          <ul>
                            <li>
                              <b>Extensive Knowledge:</b> Full stack developers
                              need to be proficient in both front-end and
                              back-end technologies, which can be overwhelming
                              due to the vast amount of knowledge and skills
                              required.
                            </li>

                            <li>
                              <b>Complexity:</b> Building full-fledged
                              applications from scratch can be complex and
                              time-consuming. Developers must manage databases,
                              servers, user interfaces, and more, which can lead
                              to intricate development processes.
                            </li>

                            <li>
                              <b>Resource Management:</b> Efficiently managing
                              resources like memory, server capacity, and
                              database performance is crucial. Poor resource
                              management can lead to application bottlenecks and
                              scalability issues.
                            </li>

                            <li>
                              <b>Time Management:</b> Balancing front-end and
                              back-end tasks within project timelines can be
                              challenging. Developers must allocate their time
                              effectively to ensure all aspects of the
                              application are well-developed.
                            </li>

                            <li>
                              <b>Debugging:</b> Identifying and fixing issues
                              that span both front-end and back-end components
                              can be tricky. Debugging and troubleshooting
                              skills are essential.
                            </li>

                            <li>
                              <b>Team Collaboration:</b> Full stack developers
                              often work with cross-functional teams. Effective
                              communication and collaboration with designers,
                              testers, and other developers are critical for
                              project success.
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading36">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse36"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i>What are the
                            core front-end development languages and
                            technologies?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse36"
                        className="collapse"
                        aria-labelledby="heading36"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Front-end development is a critical component of
                            full stack web development, focusing on creating the
                            user interface and enhancing the user experience. To
                            excel in front-end development, one must be
                            well-versed in several core languages and
                            technologies:
                          </p>

                          <ul>
                            <li>
                              <b>HTML (Hypertext Markup Language):</b> HTML is
                              the backbone of web development. It defines the
                              structure and content of web pages, using elements
                              like headings, paragraphs, links, and images.
                            </li>

                            <li>
                              <b>CSS (Cascading Style Sheets):</b> CSS is used
                              for styling HTML elements. It controls layout,
                              fonts, colors, and spacing, allowing developers to
                              create visually appealing and responsive web
                              designs.
                            </li>

                            <li>
                              <b>JavaScript:</b> JavaScript is a versatile
                              scripting language that adds interactivity to web
                              pages. It enables dynamic content, user
                              interactions, and data manipulation. Popular
                              JavaScript libraries and frameworks like React,
                              Angular, and Vue.js further enhance front-end
                              development.
                            </li>

                            <li>
                              <b>Responsive Web Design:</b> Ensuring that web
                              applications are accessible and functional across
                              various devices and screen sizes is essential.
                              Responsive design techniques using CSS media
                              queries are fundamental.
                            </li>

                            <li>
                              <b>Web Performance Optimization:</b> Front-end
                              developers should optimize websites for speed and
                              performance. Techniques like code minification,
                              image compression, and lazy loading improve
                              loading times.
                            </li>

                            <li>
                              <b>Version Control:</b> Knowledge of version
                              control systems like Git is vital for
                              collaborating on projects, tracking changes, and
                              maintaining code integrity.
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading37">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse37"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i>What are some
                            recommended Full Stack Developer course by
                            Logicmojo?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse37"
                        className="collapse"
                        aria-labelledby="heading37"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Logicmojo offers a variety of Full Stack Web
                            Development courses designed to cater to a wide
                            range of learners. These courses are structured to
                            equip individuals with the knowledge and skills
                            necessary to become proficient Full Stack
                            Developers.
                          </p>
                          <p>
                            Whether you're a beginner or an experienced
                            developer, Logicmojo has a course tailored to your
                            needs. The courses are designed to provide a
                            comprehensive understanding of Full Stack
                            Development, including HTML, CSS, JavaScript,
                            server-side scripting, databases, and more.
                          </p>

                          <p>
                            If you're unsure which course to choose, Logicmojo's
                            course advisors are available to assist you in
                            selecting the right program based on your background
                            and career goals. This ensures that you receive
                            personalized guidance to kickstart or advance your
                            career in Full Stack Web Development.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading38">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse38"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i>Do I Need To
                            Have Strong Programming Skills To Be A Full Stack
                            Developer?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse38"
                        className="collapse"
                        aria-labelledby="heading38"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Full stack developers play a crucial role in modern
                            web development, handling both front-end and
                            back-end tasks. While strong programming skills are
                            essential for success, the level of proficiency
                            required can vary based on individual goals and the
                            complexity of projects. Here's a breakdown:
                          </p>

                          <ul>
                            <li>
                              <b>Front-End Proficiency:</b> To excel as a full
                              stack developer, you must have a solid grasp of
                              front-end technologies, including HTML, CSS, and
                              JavaScript. Proficiency in these languages is
                              essential for creating interactive and visually
                              appealing user interfaces.
                            </li>

                            <li>
                              <b>Back-End Development:</b> For back-end
                              development, you need a deeper understanding of
                              server-side languages like Python, Ruby, Node.js,
                              or Java, depending on your project's requirements.
                              Strong programming skills are crucial here to
                              manage databases, handle server logic, and ensure
                              data security.
                            </li>

                            <li>
                              <b>Database Management:</b> Full stack developers
                              often work with databases like MySQL, MongoDB, or
                              PostgreSQL. You should be proficient in database
                              management, including designing schemas, writing
                              queries, and optimizing database performance.
                            </li>

                            <li>
                              <b>Problem-Solving:</b> Strong programming skills
                              enable you to approach complex problems logically
                              and efficiently. Full stack development often
                              involves troubleshooting issues, debugging code,
                              and finding innovative solutions.
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading39">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse39"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> How can I build
                            a strong portfolio as a Full Stack Developer?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse39"
                        className="collapse"
                        aria-labelledby="heading39"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Creating a robust portfolio as a Full Stack
                            Developer involves several key steps. First and
                            foremost, focus on building real-world projects that
                            showcase your skills. These projects should
                            encompass both front-end and back-end development,
                            demonstrating your versatility.
                          </p>

                          <p>
                            Additionally, consider contributing to open-source
                            projects to gain valuable experience and collaborate
                            with the developer community. Platforms like GitHub
                            can serve as a repository for your work, allowing
                            potential employers to assess your coding abilities.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading40">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse40"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i>What If I Miss A
                            Live Session for Full Stack Developer Course?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse40"
                        className="collapse"
                        aria-labelledby="heading40"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Missing a live session during your Full Stack
                            Development Course is not a problem. All sessions
                            are meticulously recorded and made available through
                            Logicmojo's user-friendly Learning Management System
                            (LMS).
                          </p>

                          <p>
                            With this convenient feature, you can access the
                            recorded sessions at your convenience. Whether it's
                            due to a scheduling conflict or any other reason,
                            you won't miss out on valuable course material. This
                            flexibility ensures that you can keep pace with the
                            curriculum and stay up-to-date with the course
                            content.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading41">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse41"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i>Will I Receive a
                            Course Completion Certificate?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse41"
                        className="collapse"
                        aria-labelledby="heading41"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Yes! Upon successfully completing the Full Stack Web
                            Development Course, you will be awarded a course
                            completion certificate from Logicmojo.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading42">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse42"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i>What If I Forget
                            Full Stack Development Concepts After Completion?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse42"
                        className="collapse"
                        aria-labelledby="heading42"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            We understand that retaining all the course material
                            can be challenging. That's why we've got you
                            covered. All our sessions are recorded, and you'll
                            have lifelong access to our e-learning resources.
                            So, even if you need a refresher or want to revisit
                            any concept, you can do so at your convenience.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading43">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse43"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i>What If I Have
                            No Experience In Full Stack Development?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse43"
                        className="collapse"
                        aria-labelledby="heading43"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Don't worry if you're new to Full Stack Development.
                            This field has gained significant attention in
                            recent years, leading to a high demand for skilled
                            professionals. Many companies are struggling to find
                            enough qualified individuals to fill this talent
                            gap. If you receive proper training and gain
                            exposure to Backend UI techniques through our
                            course, you'll be well-prepared to meet the demands
                            of the industry. Companies often value individuals
                            with the right skills and are quick to recruit them
                            for their Full Stack development needs.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading44">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse44"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> How are
                            assessments and grades handled?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse44"
                        className="collapse"
                        aria-labelledby="heading44"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            In Full Stack Developer Courses, assessments
                            and grading methods may vary depending on the
                            specific program and institution. Typically, these
                            courses involve a mix of assignments, projects, and
                            exams to evaluate your understanding and skills.
                            Assignments are designed to test your knowledge of
                            programming languages, web development frameworks,
                            and other related topics. Projects often involve
                            creating real-world applications to showcase your
                            ability to apply what you've learned.
                          </p>
                          <p>
                            Grading criteria can differ from one course to
                            another, but instructors generally assess your
                            performance based on the quality and functionality
                            of your assignments and projects. Some courses may
                            also have exams to test your theoretical knowledge.
                            To succeed in such courses, it's essential to
                            actively participate, complete assignments on time,
                            and seek help when needed.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading45">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse45"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> What is the
                            placement rate for this Full stack Developer
                            course?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse45"
                        className="collapse"
                        aria-labelledby="heading45"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            The placement rate for the Logicmojo Full Stack Web
                            Development course is quite promising. This course
                            equips you with the essential skills and knowledge
                            needed for various roles in the tech industry. It
                            covers a wide range of topics, including front-end
                            and back-end development, databases, and more,
                            making you a well-rounded developer.
                          </p>
                          <p>
                            Logicmojo places a strong emphasis on practical
                            training, allowing you to work on real-world
                            projects and build a portfolio that demonstrates
                            your capabilities. This hands-on experience can
                            significantly enhance your prospects in the job
                            market, as employers often seek candidates with
                            practical skills.
                          </p>
                          <p>
                            Furthermore, Logicmojo has established industry
                            partnerships, which can open doors to job fairs,
                            internships, and direct job placements with
                            reputable companies. This network can be invaluable
                            in launching your career as a full-stack developer.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading46">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse46"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> What kind of
                            companies recruit from this Full Stack Developer
                            course ?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse46"
                        className="collapse"
                        aria-labelledby="heading46"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            The Logicmojo Full Stack Developer Course
                            opens up a world of opportunities with various
                            companies across different industries. While large
                            technology giants like Google, Microsoft, Amazon,
                            and Facebook often recruit graduates and
                            professionals with expertise in full stack
                            development, there's a wide range of companies that
                            value these skills.
                          </p>
                          <p>
                            Financial institutions, including banks and
                            insurance companies, frequently hire full stack
                            developers to analyze customer data and improve
                            their business processes. These roles are critical
                            in today's data-driven world.
                          </p>
                          <p>
                            Here are some of the top companies that actively
                            seek full stack developers:
                          </p>
                          <ul>
                            <li>Cognizant Technology</li>
                            <li>Capgemini</li>
                            <li>Mindtree</li>
                            <li>Wipro</li>
                            <li>Deloitte</li>
                            <li>Accenture</li>
                            <li>IBM</li>
                          </ul>
                          <p>
                            These companies offer diverse opportunities, from
                            web application development to system integration
                            and software consulting. Completing the Logicmojo
                            Full Stack Developer Course can open doors to
                            exciting career prospects with these renowned
                            organizations.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading47">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse47"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i>What is the
                            average salary package offered to candidates after
                            completing this Full Stack Developer course?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse47"
                        className="collapse"
                        aria-labelledby="heading47"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            The Logicmojo Full Stack Developer Course
                            equips you with the skills and knowledge necessary
                            to secure highly competitive salary packages in the
                            tech industry. After successfully completing this
                            course, you can expect to earn an average annual
                            salary of ₹ 8.7 Lakhs as a Full Stack Developer in
                            India.
                          </p>
                          <p>
                            This salary range reflects the growing demand for
                            full stack developers who possess expertise in both
                            front-end and back-end technologies. Full Stack
                            Developers are versatile professionals who can
                            design user interactions, develop server-side
                            applications, code for mobile platforms, and create
                            APIs. Their ability to work across the entire
                            technology stack makes them invaluable to companies
                            of all sizes.
                          </p>
                          <p>
                            While the salary may vary based on factors such as
                            location, experience, and the specific organization
                            you join, the Logicmojo Full Stack Developer
                            course opens doors to numerous lucrative
                            opportunities. Large technology companies, financial
                            institutions, consulting firms, and startups are
                            among the potential employers eager to hire skilled
                            full stack developers.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading48">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse48"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> Are there any
                            networking opportunities with potential employers?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse48"
                        className="collapse"
                        aria-labelledby="heading48"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Yes, the Logicmojo Full Stack Developer Course
                            provides valuable networking opportunities with
                            potential employers, enhancing your chances of
                            landing your dream job in the tech industry.
                          </p>
                          <p>
                            Throughout the course, students often have the
                            chance to participate in networking events and job
                            fairs. These events serve as a bridge between
                            learners and prospective employers. They offer a
                            platform for students to showcase their skills,
                            engage in meaningful conversations with industry
                            professionals, and even secure interviews or
                            internships.
                          </p>
                          <p>
                            Networking in the tech industry is invaluable, as it
                            can lead to mentorship, job referrals, and exposure
                            to the latest trends and job openings. Logicmojo
                            recognizes the importance of these connections and
                            actively facilitates them through partnerships with
                            various companies.
                          </p>
                          <p>
                            By attending networking events and job fairs, you
                            can gain insights into the job market, learn about
                            different career paths, and establish connections
                            that may shape your professional journey. These
                            opportunities are not only informative but also
                            crucial for building a successful career in full
                            stack development.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading49">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse49"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> Are there any
                            prerequisites required for placement after
                            completing this Full Stack Developer course?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse49"
                        className="collapse"
                        aria-labelledby="heading49"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            No, Logicmojo's Full Stack Developer Course
                            does not have specific prerequisites for placement.
                            The course is designed to cater to both beginners
                            and experienced professionals looking to enhance
                            their web development skills. Whether you are
                            starting from scratch or seeking to expand your
                            expertise, this course equips you with the necessary
                            knowledge and hands-on experience to excel in the
                            field.
                          </p>
                          <p>
                            Upon successful completion, you'll gain valuable
                            skills in front-end and back-end development,
                            enabling you to pursue a wide range of job
                            opportunities. Logicmojo also provides placement
                            assistance and connects learners with a network of
                            potential employers, making it easier for you to
                            transition into a rewarding career in web
                            development.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading50">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse50"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> Is there any
                            assistance provided by Logicmojo for resume building
                            and interview preparation for placement?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse50"
                        className="collapse"
                        aria-labelledby="heading50"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Absolutely, Logicmojo offers valuable support to
                            prepare you for job placement in the Full Stack Web
                            Development field. After successfully completing the
                            course, which typically spans 7 months, you will be
                            well-prepared for interviews. Logicmojo takes your
                            readiness seriously and offers personalized
                            assistance.
                          </p>
                          <p>
                            First, there is a one-on-one resume preparation
                            session to help you create an impactful resume that
                            highlights your skills and accomplishments.
                            Following this, mock interviews are conducted to
                            sharpen your interview skills and build your
                            confidence.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading51">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse51"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> How long does
                            it take for students to get placed after completing
                            this Full Stack Developer course?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse51"
                        className="collapse"
                        aria-labelledby="heading51"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            The duration for students to secure a position after
                            completing a Full Stack Developer course can vary
                            significantly. Several factors come into play:
                          </p>
                          <ul>
                            <li>
                              Skill Set and Expertise: The depth of your skills
                              and expertise in Full Stack Development influences
                              your employability.
                            </li>
                            <li>
                              Portfolio of Projects: A strong portfolio
                              showcasing your practical experience and project
                              work can expedite the job search.
                            </li>
                            <li>
                              Internships and Work Experience: Prior internships
                              and work experience can accelerate the placement
                              process.
                            </li>
                          </ul>
                          <p>
                            These variables mean that some individuals may land
                            a job shortly after course completion, while others
                            might take more time to align their skills and
                            experiences with job requirements. Dedication to
                            continuous learning and enhancing your portfolio can
                            help expedite the job placement process.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading52">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse52"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> What is the
                            role of the Logicmojo in ensuring the placement of
                            its students?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse52"
                        className="collapse"
                        aria-labelledby="heading52"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Logicmojo plays a crucial role in securing
                            placements for its students by offering a
                            comprehensive education and training program. This
                            program is designed to equip students with the
                            skills and knowledge needed to excel in the
                            industry. Moreover, Logicmojo extends support
                            through job placement assistance initiatives. These
                            include resume building sessions, mock interviews,
                            and opportunities for networking. By preparing
                            students not only academically but also
                            professionally, Logicmojo aims to bridge the gap
                            between education and employment, increasing their
                            chances of successful placements.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading53">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse53"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> Can students
                            pursue internships or part-time jobs during the
                            course to enhance their chances of placement?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse53"
                        className="collapse"
                        aria-labelledby="heading53"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Yes, internships play a vital role in enhancing
                            students' placement opportunities in the Full Stack
                            Developer field. Logicmojo's Full Stack Developer
                            course actively supports students in securing
                            internships or pre-placement opportunities. These
                            internships offer several benefits, including
                            improved job prospects in Full Stack Development,
                            real-world remuneration, expanded professional
                            networks, and valuable insights into the workings of
                            a professional workplace. By encouraging students to
                            engage in internships or part-time roles, Logicmojo
                            empowers them with practical experience and valuable
                            industry exposure, ultimately boosting their chances
                            of successful placement.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading54">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse54"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> Are there any
                            additional certification programs offered along with
                            the Full Stack Developer course that can help with
                            placement opportunities?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse54"
                        className="collapse"
                        aria-labelledby="heading54"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Yes, Logicmojo offers additional certification
                            programs that can significantly enhance your
                            placement prospects in the field of Full Stack
                            Development. Here's how these certifications can
                            benefit you:
                          </p>
                          <ul>
                            <li>
                              <b>Specialized Skillsets:</b> These certifications
                              provide you with specialized skills in areas like
                              web development frameworks, cloud computing,
                              cybersecurity, or mobile app development.
                              Acquiring expertise in these domains can make you
                              a more attractive candidate to employers.
                            </li>
                            <li>
                              <b>Industry Recognition:</b> Certifications from
                              reputable organizations are recognized and
                              respected in the industry. They validate your
                              proficiency and dedication to continuous learning,
                              which can set you apart from other job applicants.
                            </li>
                            <li>
                              <b>Expanded Knowledge:</b> Additional
                              certifications broaden your knowledge base, making
                              you a more versatile Full Stack Developer. You'll
                              be better equipped to tackle diverse projects and
                              challenges.
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading55">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse55"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i>How can I build
                            a strong portfolio as a Full Stack Developer?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse55"
                        className="collapse"
                        aria-labelledby="heading55"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Constructing a compelling portfolio is pivotal for a
                            Full Stack Developer's career growth. Here's a
                            comprehensive strategy to help you create an
                            impressive portfolio:
                          </p>
                          <ul>
                            <li>
                              <b>Real-world Projects:</b> Undertake real
                              projects that encompass both front-end and
                              back-end development. Building web applications,
                              e-commerce sites, or content management systems
                              demonstrates your practical skills.
                            </li>
                            <li>
                              <b>Open-source Contributions:</b> Contribute to
                              open-source projects on platforms like GitHub.
                              Your contributions, bug fixes, or feature
                              additions showcase your collaborative abilities
                              and commitment to the developer community.
                            </li>
                            <li>
                              <b>Diverse Tech Stack:</b> Utilize a diverse
                              technology stack. Showcase proficiency in various
                              programming languages, frameworks, and libraries,
                              illustrating your versatility.
                            </li>
                            <li>
                              <b>Clean Code:</b> Maintain clean, well-documented
                              code. Employ best practices in coding, making your
                              projects easily understandable and maintainable.
                            </li>
                            <li>
                              <b>Showcase Problem Solving:</b> Highlight your
                              problem-solving skills by describing challenges
                              you've encountered and the solutions you've
                              implemented in your projects.
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading56">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse56"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i>Are there any
                            alumni of this Full Stack Developer course who
                            have successfully been placed in reputed companies?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse56"
                        className="collapse"
                        aria-labelledby="heading56"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            {" "}
                            Many alumni of the Full Stack Developer course at
                            Logicmojo have gone on to secure positions in
                            renowned companies across the tech industry. Here's
                            how you can explore their success stories:
                          </p>
                          <ul>
                            <li>
                              <b>Connect with Logicmojo:</b> Logicmojo can
                              provide you with information about alumni who have
                              excelled in their careers after completing the
                              course. They can connect you with these
                              accomplished professionals.
                            </li>
                            <li>
                              <b>Alumni Insights:</b> Reach out to alumni
                              directly to gain insights into their experiences.
                              They can share valuable information about their
                              journey, job search, and how the course prepared
                              them for success.
                            </li>
                            <li>
                              <b>Online Research:</b> Utilize online resources
                              and social media platforms to discover alumni
                              achievements. Many former students share their
                              career trajectories on LinkedIn, showcasing the
                              impact of their Full Stack Developer training.
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading57">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse57"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i>Can I switch
                            careers after completing this course?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse57"
                        className="collapse"
                        aria-labelledby="heading57"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Absolutely! Completing a Full Stack Developer
                            course can be a pivotal step towards transitioning
                            to a new and promising career in the tech industry.
                            Here's why:
                          </p>
                          <ul>
                            <li>
                              <b>Versatile Skill Set:</b> Full Stack Developer
                              equips you with a versatile skill set that covers
                              both front-end and back-end technologies. This
                              breadth of knowledge makes you a valuable asset in
                              various tech-related roles.
                            </li>
                            <li>
                              <b>High Demand:</b> The tech industry has a
                              constant demand for skilled Full Stack Developers.
                              This demand extends to positions such as web
                              developer, software engineer, system analyst, and
                              more.
                            </li>
                            <li>
                              <b>Career Growth:</b> With the foundational skills
                              acquired in Full Stack Development, you can climb
                              the career ladder. Your expertise can lead to
                              senior developer roles, project management, or
                              even entrepreneurship.
                            </li>
                            <li>
                              <b>Adaptability:</b> Tech is a dynamic field. Full
                              Stack Developers are well-equipped to adapt to new
                              technologies and trends, ensuring long-term career
                              relevance.
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading58">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse58"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i>What is the
                            success rate of students getting placed in their
                            preferred companies and domains after completing the
                            Logicmojo Full Stack Developer course?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse58"
                        className="collapse"
                        aria-labelledby="heading58"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Assessing the success rate of students getting
                            placed in their preferred companies and domains
                            after completing the Logicmojo Full Stack
                            Development course involves multiple factors. The
                            primary determinants include:
                          </p>
                          <ul>
                            <li>
                              <b>Skills and Proficiency:</b> The extent to which
                              students have mastered full stack development
                              technologies and programming languages like HTML,
                              CSS, JavaScript, and server-side languages is
                              pivotal.
                            </li>
                            <li>
                              <b>Portfolio:</b> The quality and diversity of
                              projects in a student's portfolio play a
                              significant role in attracting prospective
                              employers.
                            </li>
                            <li>
                              <b>Networking:</b> Active engagement with peers,
                              mentors, and industry professionals can open doors
                              to job opportunities.
                            </li>
                            <li>
                              <b>Resume Building:</b> Effective resume
                              preparation and interview readiness also influence
                              placement success.
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading59">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse59"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i>Are there any
                            placement-related policies or agreements that
                            students should be aware of before enrolling in the
                            Full Stack Developer course?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse59"
                        className="collapse"
                        aria-labelledby="heading59"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            <b></b>
                          </p>
                          <p>
                            No, our Full Stack Developer course does not have
                            schemes such as "Pay After Placement." Upon
                            enrollment with a one-time payment, the Full Stack developer
                            curriculum begins. After completing the course, the
                            placement process will commence. We do not have any
                            additional placement-related policies or agreements
                            that students need to be aware of before joining our
                            program. Our focus is on delivering quality
                            education and assisting students in their career
                            journeys.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading60">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse60"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i>Until when will
                            the Logicmojo students get the facility of
                            mentorship?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse60"
                        className="collapse"
                        aria-labelledby="heading60"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Our Full Stack Developer Course provides
                            mentorship throughout the program, with mentors
                            specializing in relevant subjects. Upon course
                            completion, students can continue to benefit from
                            mentor support for projects and job placement. This
                            ongoing mentorship ensures that students receive
                            guidance and assistance beyond the classroom,
                            helping them apply their skills effectively in
                            real-world scenarios and facilitating their
                            transition into the job market.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading61">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse61"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> Can a student
                            choose to study from their desired mentor?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse61"
                        className="collapse"
                        aria-labelledby="heading61"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            At Logicmojo, we understand that a strong
                            mentor-student relationship is essential for
                            effective learning. While each batch is assigned a
                            dedicated mentor, we recognize that students may
                            have unique preferences. If a student finds that
                            their assigned mentor doesn't align with their
                            learning style or needs, they have the option to
                            raise the concern with our management. We are
                            committed to ensuring a positive and productive
                            learning experience, and in such cases, we will work
                            to provide alternative mentorship options that
                            better suit the student's requirements. Our goal is
                            to empower students to make the most out of their
                            Full Stack Development journey.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading62">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse62"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> What is the
                            experience level of the mentors teaching the Full
                            Stack Development course?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse62"
                        className="collapse"
                        aria-labelledby="heading62"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Our Full Stack Developer Course is led by
                            mentors with extensive industry experience, ensuring
                            that students receive top-notch guidance. Our
                            instructors possess in-depth knowledge and hands-on
                            expertise in the field of Full Stack Development.
                            With backgrounds as seasoned professionals and
                            consultants, they bring real-world insights to the
                            classroom. Their wealth of experience equips
                            students with practical skills and industry-relevant
                            knowledge, enabling them to excel in their Full
                            Stack Development journey. We are committed to
                            providing the best learning experience by offering
                            mentorship from experts who can guide and inspire
                            our students to achieve their goals.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading63">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse63"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> How many
                            mentors will be assigned to each student during the
                            course?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse63"
                        className="collapse"
                        aria-labelledby="heading63"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            In our Full Stack Developer Course, typically
                            one dedicated instructor is assigned to each batch.
                            However, we prioritize adaptability and can schedule
                            multiple trainers based on specific requirements and
                            preferences. Our primary aim is to provide
                            top-quality training through effective teaching
                            methods. Ensuring that students receive the
                            necessary attention and support is our utmost
                            priority. If students have particular needs or
                            preferences, we encourage open communication through
                            Slack, and we are ready to tailor our approach to
                            meet those needs promptly.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading64">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse64"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> What kind of
                            support can students expect from their mentors
                            during the course?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse64"
                        className="collapse"
                        aria-labelledby="heading64"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            In our Full Stack Developer Course, students
                            can anticipate comprehensive support from their
                            mentors throughout the program. Alongside regular
                            live classes, our mentors are available to assist
                            students with any full stack development inquiries via a
                            dedicated Slack channel at any time. We acknowledge
                            that questions may arise unexpectedly, and our
                            commitment is to ensure students receive timely
                            guidance. Additionally, we schedule dedicated live
                            doubt sessions during weekdays after office hours,
                            catering to the needs of working professionals. Our
                            primary objective is to empower our students to
                            thrive in their Full Stack Web Development journey.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading65">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse65"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> Are the mentors
                            available for one-on-one sessions outside of the
                            regular class schedule ?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse65"
                        className="collapse"
                        aria-labelledby="heading65"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Yes, in our Full Stack Developer Course,
                            mentors are readily available for one-on-one
                            sessions beyond the standard class schedule. We
                            recognize that students may have specific queries or
                            require additional assistance, and we prioritize
                            meeting their individual needs. Students can easily
                            arrange one-on-one sessions with their assigned
                            mentor at a mutually convenient time. Our mentors
                            are dedicated to supporting students in their
                            journey to success and are committed to addressing
                            any concerns or questions they may have outside of
                            regular class hours.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading66">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse66"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> Will students
                            have access to mentors even after completing the
                            Full Stack Developer course?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse66"
                        className="collapse"
                        aria-labelledby="heading66"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            In our Full Stack Developer course, which spans
                            over 7 months, students continue to have access to
                            our dedicated mentors even after they have
                            successfully completed the program. Our mentors are
                            readily available to assist students with any
                            queries or challenges they may encounter. Students
                            can easily reach out to mentors through the
                            communication platform Slack, where direct messaging
                            is possible. For urgent matters or those requiring a
                            more in-depth discussion, students also have the
                            option to schedule a one-on-one call with their
                            respective trainers. We understand the value of
                            ongoing support, and our mentors are committed to
                            providing it to our students.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading67">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse67"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> What is the
                            class size for the Full Stack Developer Course?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse67"
                        className="collapse"
                        aria-labelledby="heading67"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            The class size for our Full Stack Developer Course
                            can vary from batch to batch, depending on the
                            number of enrolled students. However, our primary
                            focus is on catering to the needs of working
                            professionals. We understand that our students have
                            busy schedules, and as a result, we offer flexible
                            learning options to accommodate their requirements.
                            Our commitment is to provide high-quality training
                            that is not only industry-relevant but also empowers
                            our students to advance in their careers. We believe
                            in delivering education that aligns with the dynamic
                            demands of the technology sector.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading68">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse68"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> How frequently
                            are Full Stack Developer Course classes conducted?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse68"
                        className="collapse"
                        aria-labelledby="heading68"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Our Full Stack Developer Course is designed to
                            accommodate the diverse schedules of our students.
                            We offer both weekend and weekday classes, catering
                            to your availability. Our weekend sessions are
                            comprehensive, with each class spanning 180 minutes,
                            while our weekday sessions are condensed to 120
                            minutes. This flexibility ensures that you can
                            choose the course timing that best suits your
                            lifestyle and commitments, making it easier for you
                            to pursue your Full Stack Development education
                            without compromising on your other responsibilities.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading69">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse69"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> Can I switch
                            from self-paced training to instructor-led training
                            in the Full Stack Developer Course?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse69"
                        className="collapse"
                        aria-labelledby="heading69"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Absolutely, transitioning from self-paced training
                            to online instructor-led training is seamless. You
                            can make the switch by simply covering the
                            additional cost. Once you've decided to switch,
                            you'll be able to join the upcoming instructor-led
                            batch, and we'll ensure you receive timely
                            notifications about it. This flexibility allows you
                            to adapt your learning style to your evolving needs
                            and preferences, ensuring that you have the best
                            possible experience in our Full Stack Web
                            Development Course.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading70">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse70"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> Is peer
                            interaction and project collaboration encouraged
                            during the Full Stack Developer Course?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse70"
                        className="collapse"
                        aria-labelledby="heading70"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Absolutely, collaboration and peer interaction are
                            highly encouraged in our Full Stack Developer
                            Course. We believe that learning is enhanced when
                            students work together and share ideas. Throughout
                            the course, students have opportunities to:
                          </p>
                          <ul>
                            <li>
                              Collaborate on group projects, fostering teamwork
                              and practical experience.
                            </li>
                            <li>
                              Participate in discussion forums and Slack
                              communities for knowledge sharing.
                            </li>
                            <li>
                              Engage in peer code reviews to improve coding
                              skills and gain diverse perspectives.
                            </li>
                            <li>
                              Attend live online classes to interact with
                              instructors and fellow learners.
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading71">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse71"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> How is the
                            feedback system structured for students to offer
                            input on mentors and the course curriculum?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse71"
                        className="collapse"
                        aria-labelledby="heading71"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            In our Full Stack Developer Course, we
                            prioritize student feedback as an integral part of
                            continuous improvement. We have established a
                            comprehensive feedback system that encourages
                            students to provide their insights on both mentors
                            and the course curriculum. This system typically
                            includes:
                          </p>
                          <ul>
                            <li>
                              Regular surveys and evaluations to gather opinions
                              on mentors' performance and effectiveness.
                            </li>
                            <li>
                              Channels for students to express thoughts on the
                              course content, structure, and materials.
                            </li>
                            <li>
                              Anonymity options to ensure candid feedback.
                            </li>
                            <li>
                              A responsive approach to addressing concerns and
                              implementing suggested improvements.
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div className="card">
                      <div className="card-header" id="heading007">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse007"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> What kind of
                            support we will get in Full Stack Developer Course
                            ?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse007"
                        className="collapse"
                        aria-labelledby="heading007"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            In our comprehensive Full Stack Developer Course,
                            you can expect robust support mechanisms designed to
                            enhance your learning experience. These include:
                          </p>
                          <ul>
                            <li>
                              Access to a rich repository of course materials.
                            </li>
                            <li>
                              Participation in live online classes to engage
                              with instructors and peers.
                            </li>
                            <li>
                              Access to discussion forums for collaborative
                              learning and query resolution.
                            </li>
                            <li>
                              Opportunities for peer-to-peer learning, fostering
                              a sense of community and knowledge sharing.
                            </li>
                            <li>
                              Personalized feedback and guidance from
                              experienced trainers.
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading017">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse017"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> How can I
                            access the course materials of Full Stack Web
                            Development?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse017"
                        className="collapse"
                        aria-labelledby="heading017"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            To access the course materials for Full Stack Web
                            Development, the course provider utilizes a
                            user-friendly platform, Slack. Within this platform,
                            they share a wealth of valuable resources, including
                            class recordings, assignments, and course materials.
                            These materials are readily available for download
                            by all course participants, fostering a flexible and
                            accessible learning environment. This approach
                            allows students to refer to the course content at
                            their own convenience and pace, ensuring that they
                            can make the most of their learning experience.
                            Additionally, Slack serves as a centralized hub for
                            course-related communication and resource sharing,
                            enhancing the overall educational experience.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading027">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse027"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> What is a Flexi
                            Subscription in Full Stack Developer course ?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse027"
                        className="collapse"
                        aria-labelledby="heading027"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            In the context of the Full Stack Developer
                            Course, a Flexi Subscription offers valuable
                            flexibility to students. It acknowledges that life
                            can sometimes bring unexpected challenges, such as
                            medical emergencies, work demands, or on-site job
                            opportunities. In such situations, students have the
                            option to switch to another course batch without
                            incurring any penalties. This means they can
                            temporarily pause their current batch and seamlessly
                            resume their learning journey when they are ready.
                            This accommodating feature ensures that students can
                            adapt to changing circumstances while pursuing their
                            education in full stack development.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading037">
                        <h3 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse037"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> Is there a
                            discussion forum for the course ?
                          </button>
                        </h3>
                      </div>

                      <div
                        id="collapse037"
                        className="collapse"
                        aria-labelledby="heading037"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Yes, Logicmojo employs a dedicated Slack channel for
                            seamless communication and collaboration among
                            course participants. This Slack community serves as
                            an interactive forum where users can readily connect
                            with their peers to seek assistance and address
                            queries related to the Full Stack Developer
                            Course. It offers a platform for engaging
                            discussions, sharing insights, and fostering a sense
                            of community among learners, enhancing the overall
                            learning experience.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>


      </section>


      <div ref={contactSection} className="supportbgnew" id="contact">
        <div className="container">
          <h2 style={{ fontSize: '32px', fontFamily: "'DM Serif Display', serif" }}><b>Contact Us 24/7</b> : Learner’s Support</h2>
          <div className="supportbgnew-inner">
            <div className="supportbgnew-inner-img">
              <img src="assets/images/supportimg.png" alt="" />
            </div>
            <div className="supportbgnew-inner-content">
              <h4>Got more questions?</h4>
              <h3>Talk to our team directly</h3>
              <p>
                Reach us and a learning consultant will get in touch with you
                shortly
              </p>

              <a href="">
                <i className="fa fa-whatsapp"></i> Enquire now
              </a>
              <a href="" style={{ background: "#1a64c0" }}>
                <i className="fa fa-whatsapp"></i> +91 80889-75867
              </a>
            </div>

          </div>
          <center className="clearfix float-left w-100">
            <div className="social-icons">

              <i className="fa fa-youtube-play"></i><a href="https://www.youtube.com/@logicmojo/videos" target="_blank">
                Youtube
              </a>

              <i className="fa fa-facebook-f"></i><a href="https://www.facebook.com/logicmojo/" target="_blank" >
                Facebook
              </a>


              <i className="fa fa-twitter"></i><a href="https://twitter.com/logic_mojo" target="_blank" title="Follow us on Twitter">
                Twitter
              </a>


              <i className="fa fa-linkedin-square"></i><a href="https://www.linkedin.com/company/82779427" target="_blank" title="Connect with us on LinkedIn">
                LinkedIn
              </a>


              <i className="fa fa-instagram"></i><a href="https://www.instagram.com/logicmojo/" target="_blank" title="Follow us on Instagram">
                Instagram
              </a>
            </div>
          </center>
        </div>



      </div>


      <div className="footerai">
        <div className="container">
          <div className="row">
            <div className="col-md-6 col-lg-3">
              <p>
                <img src="assets/images/logo.png" alt="" />
              </p>
              <p>
                Enrol Now For Full Stack developer Course, System Designing Or Full
                Stack Development Courses. Master The Most Demanding Skills Of
                Job Market And Experience And Ever Growing And Lucrative Career
                Transformation.
              </p>
              <p>
                <a href="mailto:info@logicmojo.com">
                  <i className="fa fa-envelope-o"></i>Email:  info@logicmojo.com
                </a>
              </p>
              <p>
                <a href="tel:+91 80889-75867">
                  <i className="fa fa-phone"></i> Ph:  +91 80889-75867
                </a>
              </p>
              <p>
                <a href="">
                  <i className="fa fa-address-card"></i> Address: Vidya Vikas School Rd, New Kaverappa Layout, Kaverappa Layout, Kadubeesanahalli, Panathur, Bengaluru, Karnataka 560103
                </a>
              </p>
              
            </div>
            {
              <div className="col-md-6 col-lg-4">
                <h3>Additional Full Stack Development Learning Resources</h3>
                <p>
                  <Link to="https://logicmojo.com/full-stack-developer">
                    Full Stack Developer
                  </Link>
                </p>
                <p>
                  <Link to="https://logicmojo.com/full-stack-developer-salary">
                    Full Stack Developer Salary
                  </Link>
                </p>
                <p>
                  <Link to="https://logicmojo.com/spring-boot-interview-questions">
                    Spring Boot Interview Questions
                  </Link>
                </p>
                <p>
                  <Link to="https://logicmojo.com/react-js-interview-questions">
                    ReactJS Interview Questions
                  </Link>
                </p>
                <p>
                  <Link to="https://logicmojo.com/javascript-interview-questions">
                    Javascript Interview Questions
                  </Link>
                </p>
                <p>
                  <Link to="https://logicmojo.com/mysql-interview-questions">
                    MySQL Interview Questions
                  </Link>
                </p>
                <p>
                  <Link to="https://logicmojo.com/microservices-interview-questions">
                    Microservices Interview Questions
                  </Link>
                </p>
                <p>
                  <Link to="https://logicmojo.com/sql-interview-questions">
                    SQL Interview Questions
                  </Link>
                </p>
                <p>
                  <Link to="https://logicmojo.com/angular-interview-questions">
                    Angular Interview Questions
                  </Link>
                </p>
                <p>
                  <Link to="https://logicmojo.com/angular-vs-react">
                    Angular vs React
                  </Link>
                </p>
                <p>
                  <Link to="https://logicmojo.com/nosql-database">
                    NoSQL Database
                  </Link>
                </p>
                <p>
                  <Link to="https://logicmojo.com/html-interview-questions">
                    HTML Interview Questions
                  </Link>
                </p>
                <p>
                  <Link to="https://logicmojo.com/devops-interview-questions">
                    DevOps Interview Questions
                  </Link>
                </p>
              </div>
            }
            <div className="col-md-6 col-lg-2">
              <h3>Logicmojo</h3>
              <p>
                <a href="https://logicmojo.com/about_us">About Us</a>
              </p>

              <p>
                <a href="https://logicmojo.com/blog">Blogs</a>
              </p>
            </div>
            <div className="col-md-6 col-lg-3">
              <h3>Terms</h3>
              <p>
                <a href="https://logicmojo.com/terms_condition">
                  Terms and Conditions
                </a>
              </p>
              <p>
                <a href="https://logicmojo.com/refund_policy">
                  Refund/Cancellation policy
                </a>
              </p>
              <p>
                <a href="https://logicmojo.com/privacy_policy">
                  Privacy Policy
                </a>
              </p>
            </div>
          </div>

          <hr />
          {/*
          <div className="row">
            <div className="col-md-12 col-lg-12">
              <h3>Project Innovation Lab Address</h3>
            </div>
            <div className="col-md-6 col-lg-3">
              <h3>Pune</h3>
              <p>
                Sky Loft Group Floor, Creaticity Mall, Opposite Golf Course,
                Airport Rd, Shastrinagar, Yerawada, Pune, Maharashtra 411006
              </p>
            </div>
            <div className="col-md-6 col-lg-3">
              <h3>Mumbai</h3>
              <p>
                Business Centre, 3rd Floor, vinkat House, Dinshaw Vacha Road,
                Churchgate, Mumbai, Maharashtra 400020
              </p>
            </div>
            <div className="col-md-6 col-lg-3">
              <h3>Delhi</h3>
              <p>
                Business Centre Park, Arunachal Building, 8th Floor, Barakhamba
                Road, New Delhi 110001
              </p>
            </div>
            <div className="col-md-6 col-lg-3">
              <h3>Kolkata</h3>
              <p>
                Ambuja Neotia EcoCentre 5th Floor, EM-4,EM-Block, Sector 6
                Kolkata 700091
              </p>
            </div>
            <div className="col-md-6 col-lg-3">
              <h3 className="mt-3">Hyderabad</h3>
              <p>
                NSL Centrum, Road No 1, Lane, Opp. Forum Mall Central Hub, KPHB
                4th Phase, Hyderabad, Telangana 500072
              </p>
            </div>
            <div className="col-md-6 col-lg-3">
              <h3 className="mt-3">Bangalore</h3>
              <p>
                #23, Above Veena Mobiles, 14th Main Road, Opp-White House,
                Sector 2, Hsr Layout, Bangalore 560102
              </p>
            </div>
            <div className="col-md-6 col-lg-3">
              <h3 className="mt-3">Chennai</h3>
              <p>
                Cessanana Business Centre, Phone Booth, 3rd Floor, 39/12 Haddows
                Road, Nungambakkam, Chennai 600 006
              </p>
            </div>
          </div>
          */}

          <hr />
          {/*
          <div className="row">
             <div className='col-md-6 col-lg-3'>
                <h3>Bangalore</h3>
                <p><a href="#">Data Science Course Training In Bangalore</a></p>
                <p><a href="#">Machine Learning Course Training In Bangalore</a></p>
                <p><a href="#">Data Analytics Course Training In Bangalore</a></p>
                <p><a href="#">Business Analytics Course Training In Bangalore</a></p>
                <p><a href="#">Artificial Intelligence AI Course Training Bangalore</a></p>
                <p><a href="#">Full-Stack Software Developer Course In Bangalore</a></p>
            </div>
            <div className='col-md-6 col-lg-3'>
                <h3>Hyderabad</h3>
                <p><Link to="/Data-Science-Course-Hydrabad">Data Science Course Training In Hyderabad</Link></p>
                <p><a href="#">Machine Learning Course Training In Hyderabad</a></p>
                <p><a href="#">Data Analytics Course Training In Hyderabad</a></p>
                <p><a href="#">Business Analytics Course Training In Hyderabad</a></p>
                <p><a href="#">Artificial Intelligence AI Course Training Hyderabad</a></p>
                <p><a href="#">Full-Stack Software Developer Course In Hyderabad</a></p>
            </div>
            <div className='col-md-6 col-lg-3'>
                <h3>Dubai</h3>
                <p><a href="#">Data Science Course Training In Dubai</a></p>
                <p><a href="#">Machine Learning Course Training In Dubai</a></p>
                <p><a href="#">Data Analytics Course Training In Dubai</a></p>
                <p><a href="#">Business Analytics Course Training In Dubai</a></p>
                <p><a href="#">Artificial Intelligence AI Course Training Dubai</a></p>
                <p><a href="#">Full-Stack Software Developer Course In Dubai</a></p>
            </div>
            <div className='col-md-6 col-lg-3'>
                <h3>Delhi</h3>
                <p><a href="#">Data Science Course Training In Delhi</a></p>
                <p><a href="#">Machine Learning Course Training In Delhi</a></p>
                <p><a href="#">Data Analytics Course Training In Delhi</a></p>
                <p><a href="#">Business Analytics Course Training In Delhi</a></p>
                <p><a href="#">Artificial Intelligence AI Course Training Delhi</a></p>
                <p><a href="#">Full-Stack Software Developer Course In Delhi</a></p>
            </div> 
          </div>
        */}

          <hr />

          <div className="row">
            <div className="col-lg-12">
              <p className="m-0">© 2023 LOGICMOJO. ALL RIGHTS RESERVED</p>
            </div>
          </div>
        </div>
      </div>
      {/*
      <div className="modal" id="welcomepopup">
        <div className="modal-header">
          <p>
            <span className="yallowbox">Full Stack Developer Live Classes </span>
          </p>
          <button type="button" className="close" data-dismiss="modal">
            ×
          </button>
        </div>
        <div className="modal-body">
          <p>
            Full Stack Developer Course
            <br />
            <b>
              <p style={{ textDecoration: "underline", color: "#007bff" }}>
                (Duration: 7 months)
              </p>
            </b>
          </p>

          <div className="modal-body">
            <p>Weekend Batch : 9 AM - 12 PM (IST)</p>
          </div>
          <div className="modal-body">
            <p>Weekend Batch : 9 AM - 12 PM (IST)</p>
          </div>

          <div className="modal-footer">
            <a
              target="_default"
              href="https://calendly.com/logicmojo/30min"
              className="btn btn-primary"
            >
              <b>Apply Now</b>
            </a>
          </div>
        </div>
      </div>
      */}
      <div className="footerstrip-formob">
        <a href="https://api.whatsapp.com/send?phone=+918088975867&amp;text=Hi%20Logicmojo">
          Chat with us{" "}
          <img
            src="assets/images/whatsapp logo.png"
            width="30"
          />
        </a>{" "}
        |{" "}
        <a
          target="_default"
          href="https://calendly.com/logicmojo/30min"
        >
          Call Back{" "}
          <img
            src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ_iRdNR098BeHs9symwbCwLZ3YJCYDfVeqjQ&amp;usqp=CAU"
            width="30"
          />
        </a>
      </div>
      <div className="footerstrip">
        <a
          target="_default"
          href="https://calendly.com/logicmojo/30min"
        >
          <span>
            <i className="fa fa-hand-o-right" aria-hidden="true"></i>{" "}
            <b>
              <u>+91 8088975867</u>
            </b>
          </span>
          <span>
            <i className="fa fa-volume-control-phone" aria-hidden="true"></i>{" "}
            <b>Talk To Our Tech Team</b>{" "}
          </span>
          <span>
            <i className="fa fa-question-circle" aria-hidden="true"></i> Any query
            related to live classes
          </span>
        </a>
      </div>
    </div>
  );
}

export default Home;
